import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table } from "antd";
import {
  FaTachometerAlt,
  FaGlobe,
  FaCity,
  FaUmbrellaBeach,
  FaCog,
  FaUsers,
  FaClock,
  FaChartLine,
  FaCogs,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaEdit,
  FaTrash,
  FaPlus,
  FaSearch,
  FaEye,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaUserFriends,
  FaList,
  FaFilter,
  FaDownload,
  FaUser,
  FaCaretDown,
  FaSave,
  FaTimes as FaClose,
  FaBuilding,
  FaChartPie,
  FaFilePdf,
  FaPaperPlane,
  FaUpload,
} from "react-icons/fa";
import { FiSearch, FiFilter, FiDownload, FiPlus, FiMoreVertical } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import AdminDocumentUploader from "./AdminDocumentUploader";
import AdminDocumentViewer from "./AdminDocumentViewer";
import AdminCustomActivityModal from "./admin/AdminCustomActivityModal";

const API_BASE_URL = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";

const AdminActivity = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("dashboard");
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  // Filter states
  const [countryFilter, setCountryFilter] = useState(""); // For cities table
  const [cityFilter, setCityFilter] = useState(""); // For activities table
  const [activityFilter, setActivityFilter] = useState(""); // For activity options table (old, can be removed later)

  // Additional filters for activity options table
  const [optionCountryFilter, setOptionCountryFilter] = useState(""); // For activity options table
  const [optionCityFilter, setOptionCityFilter] = useState(""); // For activity options table
  const [optionActivityFilter, setOptionActivityFilter] = useState(""); // For activity options table

  // Stats state
  const [stats, setStats] = useState({
    totalCountries: 0,
    totalCities: 0,
    totalActivities: 0,
    totalBookings: 0,
    totalRevenue: 0,
    totalUsers: 0,
  });

  // Data states
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [activities, setActivities] = useState([]);
  const [activityOptions, setActivityOptions] = useState([]);
  const [visitorTypes, setVisitorTypes] = useState([]);
  const [timePricing, setTimePricing] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [selectedActivityBooking, setSelectedActivityBooking] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [bookingStatusFilter, setBookingStatusFilter] = useState(""); // "" = All, pending, confirmed, rejected, etc.
  const [bookingStatusUpdating, setBookingStatusUpdating] = useState(false); // for Approve/Reject in modal
  const [eTicketUploading, setETicketUploading] = useState(false);
  const [confirmationSending, setConfirmationSending] = useState(false);
  const [timeSlotsModalOption, setTimeSlotsModalOption] = useState(null);
  const [timeSlotsList, setTimeSlotsList] = useState([]);
  const [newSlotForm, setNewSlotForm] = useState({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" });
  const [timeSlotsLoading, setTimeSlotsLoading] = useState(false);
  const [editingSlotId, setEditingSlotId] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [editingCurrency, setEditingCurrency] = useState(null);
  const [currencyFormData, setCurrencyFormData] = useState({ code: "", name: "", symbol: "", multiplier: 1, format: "1,234.56", isBase: false });

  // Form states
  const [newCountry, setNewCountry] = useState({
    name: "",
    currency: "INR",
    currencySymbol: "₹",
    active: true,
    imageUrl: "",
  });
  const [newCity, setNewCity] = useState({
    countryId: "",
    name: "",
    timezone: "Asia/Kolkata",
    active: true,
    imageUrl: "",
  });
  const [activityImageUrlInput, setActivityImageUrlInput] = useState("");
  const [newActivity, setNewActivity] = useState({
    cityId: "",
    name: "",
    description: "",
    duration: 60,
    maxCapacity: 10,
    status: "active",
  });
  const [newOption, setNewOption] = useState({
    activityId: "",
    name: "",
    basePrice: 0,
    duration: 60,
    maxCapacity: 10,
    includesTransfers: false,
    active: true,
    bookingStartDate: "",
    bookingEndDate: "",
    advanceBookingDays: "",
    pricingTiers: [],
  });
  /** Time slots to create when adding a new activity option (same UI as booking date range). */
  const [newOptionTimeSlots, setNewOptionTimeSlots] = useState([]);
  const [newVisitorType, setNewVisitorType] = useState({
    name: "",
    minAge: 0,
    maxAge: 100,
    priceMultiplier: 1.0,
    active: true,
  });

  // Modal states
  const [showAddModal, setShowAddModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [editingItem, setEditingItem] = useState(null);
  const [editFormData, setEditFormData] = useState({});

  // State for cascading dropdowns in activity option form
  const [optionSelectedCountry, setOptionSelectedCountry] = useState("");
  const [optionSelectedCity, setOptionSelectedCity] = useState("");
  const [timePricingSelectedCountry, setTimePricingSelectedCountry] = useState("");
  const [timePricingSelectedCity, setTimePricingSelectedCity] = useState("");
  const [timePricingSlots, setTimePricingSlots] = useState([]);
  const [newTimePricing, setNewTimePricing] = useState({
    activityId: "",
    activityOptionId: "",
    days: [],
    timeSlotIds: [],
    multiplier: 1.0,
    label: "",
    active: true,
  });

  // Image upload states
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [existingImages, setExistingImages] = useState([]);

  // Fetch dashboard data
  useEffect(() => {
    fetchDashboardData();
  }, [activeSection]);

  const fetchCountriesOnly = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/activity/admin/countries`);
      setCountries(response.data?.data || []);
    } catch (err) {
      console.warn("Failed to refresh countries:", err.message);
    }
  };

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      // Base endpoints that should exist
      const endpoints = [
        { key: "countries", url: `${API_BASE_URL}/api/activity/admin/countries` },
        { key: "cities", url: `${API_BASE_URL}/api/activity/admin/cities` },
        { key: "activities", url: `${API_BASE_URL}/api/activity/admin/activities` },
      ];

      const results = {};

      // Fetch data with error handling for each endpoint
      for (const endpoint of endpoints) {
        try {
          const response = await axios.get(endpoint.url);
          results[endpoint.key] = response.data?.data || [];
        } catch (error) {
          console.warn(`Failed to fetch ${endpoint.key}:`, error.message);
          results[endpoint.key] = [];
        }
      }

      // Set states with fallback empty arrays
      setCountries(results.countries);
      setCities(results.cities);
      setActivities(results.activities);

      // Update stats
      setStats({
        totalCountries: results.countries.length || 0,
        totalCities: results.cities.length || 0,
        totalActivities: results.activities.length || 0,
        totalBookings: 0, // You need to implement booking endpoint
        totalRevenue: 0,
        totalUsers: 0,
      });

      // Fetch additional data based on active section
      if (activeSection === "options") {
        try {
          const [optionsRes, visitorRes] = await Promise.all([
            axios.get(`${API_BASE_URL}/api/activity/admin/activity-options`),
            axios.get(`${API_BASE_URL}/api/activity/admin/visitor-types`),
          ]);
          setActivityOptions(optionsRes.data?.data || []);
          setVisitorTypes(visitorRes.data?.data || []);
        } catch (error) {
          console.warn("Failed to fetch options:", error.message);
          setActivityOptions([]);
        }
      }

      if (activeSection === "visitor-types") {
        try {
          const visitorTypesRes = await axios.get(
            `${API_BASE_URL}/api/activity/admin/visitor-types`
          );
          setVisitorTypes(visitorTypesRes.data?.data || []);
        } catch (error) {
          console.warn("Failed to fetch visitor types:", error.message);
          setVisitorTypes([]);
        }
      }

      if (activeSection === "time-pricing") {
        try {
          const [timePricingRes, optionsRes, visitorRes] = await Promise.all([
            axios.get(`${API_BASE_URL}/api/activity/admin/time-pricing`),
            axios.get(`${API_BASE_URL}/api/activity/admin/activity-options`),
            axios.get(`${API_BASE_URL}/api/activity/admin/visitor-types`),
          ]);
          setTimePricing(timePricingRes.data?.data || []);
          setActivityOptions(optionsRes.data?.data || []);
          setVisitorTypes(visitorRes.data?.data || []);
        } catch (error) {
          console.warn("Failed to fetch time pricing:", error.message);
          setTimePricing([]);
        }
      }

      if (activeSection === "bookings") {
        try {
          const bookingsRes = await axios.get(
            `${API_BASE_URL}/api/activity/admin/bookings`
          );
          const list = bookingsRes.data?.data || [];
          setBookings(list);
          setStats((prev) => ({
            ...prev,
            totalBookings: list.length,
            totalRevenue: list.reduce((sum, b) => sum + (Number(b.totalPrice) || 0), 0),
          }));
        } catch (error) {
          console.warn("Failed to fetch bookings:", error.message);
          setBookings([]);
        }
      }

      if (activeSection === "currencies") {
        try {
          const curRes = await axios.get(`${API_BASE_URL}/api/activity/admin/currencies`);
          setCurrencies(curRes.data?.data || []);
        } catch (error) {
          console.warn("Failed to fetch currencies:", error.message);
          setCurrencies([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(`Error fetching data: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // CRUD Operations
  // handleCreate function mein time-pricing case ko update karo
  const handleCreate = async (type, data, imageFile = null, imageFiles = null) => {
    try {
      let endpoint = "";
      let successMessage = "";

      // Create FormData for image uploads
      const formData = new FormData();

      switch (type) {
        case "country":
          endpoint = `${API_BASE_URL}/api/activity/admin/countries`;
          successMessage = "Country created successfully!";
          formData.append("name", String(data.name ?? "").trim());
          formData.append("currency", String(data.currency ?? "USD").trim());
          formData.append("currencySymbol", String(data.currencySymbol ?? "$").trim());
          formData.append("active", data.active !== undefined ? data.active : true);
          if (imageFile && typeof imageFile === "object" && imageFile instanceof File) {
            formData.append("image", imageFile);
          } else if (data.imageUrl && String(data.imageUrl).trim().startsWith("http")) {
            formData.append("imageUrl", data.imageUrl.trim());
          }
          break;
        case "city":
          endpoint = `${API_BASE_URL}/api/activity/admin/cities`;
          successMessage = "City created successfully!";
          formData.append("countryId", data.countryId);
          formData.append("name", data.name);
          formData.append("timezone", data.timezone);
          formData.append("active", data.active !== undefined ? data.active : true);
          if (imageFile) {
            formData.append("image", imageFile);
          } else if (data.imageUrl && String(data.imageUrl).trim().startsWith("http")) {
            formData.append("image", data.imageUrl.trim());
          }
          break;
        case "activity":
          endpoint = `${API_BASE_URL}/api/activity/admin/activities`;
          successMessage = "Activity created successfully!";
          formData.append("cityId", data.cityId);
          formData.append("name", data.name);
          formData.append("description", data.description);
          formData.append("duration", data.duration);
          formData.append("maxCapacity", data.maxCapacity);
          formData.append("status", data.status || "active");
          if (imageFiles && imageFiles.length > 0) {
            imageFiles.forEach((file) => {
              formData.append("images", file);
            });
          }
          if (existingImages.length > 0) {
            formData.append("images", JSON.stringify(existingImages));
          }
          break;
        case "option": {
          endpoint = `${API_BASE_URL}/api/activity/admin/activity-options`;
          successMessage = "Activity option created successfully!";
          const optionRes = await axios.post(endpoint, {
            ...data,
            allowedVisitorTypeIds: Array.isArray(data.allowedVisitorTypeIds) ? data.allowedVisitorTypeIds : [],
            includesTransfers: data.includesTransfers === true || data.includesTransfers === "true",
          });
          const createdOption = optionRes.data?.data || optionRes.data;
          const slotsToCreate = Array.isArray(newOptionTimeSlots) ? newOptionTimeSlots : [];
          if (createdOption && createdOption._id && slotsToCreate.length > 0) {
            for (const row of slotsToCreate) {
              const startTime = (row.startTime || "10:00").toString().trim();
              const endTime = (row.endTime || "11:00").toString().trim();
              const capacity = Math.max(1, parseInt(row.capacity, 10) || 10);
              if (startTime && endTime) {
                try {
                  await axios.post(`${API_BASE_URL}/api/activity/admin/time-slots`, {
                    activityOptionId: createdOption._id,
                    startTime,
                    endTime,
                    capacity,
                    label: (row.label || "").trim() || undefined,
                  });
                } catch (slotErr) {
                  console.warn("Time slot create failed:", slotErr);
                }
              }
            }
          }
          alert(`✅ ${successMessage}`);
          fetchDashboardData();
          setShowAddModal(false);
          setEditingItem(null);
          resetFormAndImages(type);
          if (createdOption && createdOption._id) {
            setTimeSlotsModalOption({ _id: createdOption._id, name: createdOption.name || "New Option" });
            setTimeSlotsLoading(true);
            setTimeSlotsList([]);
            setNewSlotForm({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" });
            setEditingSlotId(null);
            setTimeout(async () => {
              try {
                const slotsRes = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${createdOption._id}`);
                setTimeSlotsList(slotsRes.data?.data || []);
              } catch {
                setTimeSlotsList([]);
              } finally {
                setTimeSlotsLoading(false);
              }
            }, 100);
          }
          return;
        }
        case "visitor-type":
          endpoint = `${API_BASE_URL}/api/activity/admin/visitor-types`;
          successMessage = "Visitor type created successfully!";
          // Visitor types don't have images, use regular JSON
          await axios.post(endpoint, data);
          alert(`✅ ${successMessage}`);
          fetchDashboardData();
          setShowAddModal(false);
          setEditingItem(null);
          resetFormAndImages(type);
          return;
        case "time-pricing":
          endpoint = `${API_BASE_URL}/api/activity/admin/time-pricing`;
          successMessage = "Time pricing created successfully!";
          // Time pricing doesn't have images, use regular JSON
          const timePricingData = {
            activityId: data.activityId,
            activityOptionId: data.activityOptionId || null,
            days: data.days || [],
            timeSlotIds: data.timeSlotIds || [],
            multiplier: parseFloat(data.multiplier),
            label: data.label,
            active: data.active !== undefined ? data.active : true,
          };
          await axios.post(endpoint, timePricingData);
          alert(`✅ ${successMessage}`);
          fetchDashboardData();
          setShowAddModal(false);
          setEditingItem(null);
          resetFormAndImages(type);
          return;
        default:
          return;
      }

      // Send FormData for types with images (do not set Content-Type; axios adds boundary automatically)
      await axios.post(endpoint, formData, { withCredentials: true });
      alert(`✅ ${successMessage}`);
      fetchDashboardData();
      setShowAddModal(false);
      setEditingItem(null);
      resetFormAndImages(type);
    } catch (error) {
      const errMsg = error.response?.data?.error || error.message;
      if (typeof errMsg === "string" && errMsg.toLowerCase().includes("already exists")) {
        fetchDashboardData(); // refresh list so duplicate check is up to date next time
        alert("This country name is already in use. Please use a different name or edit the existing country from the list.");
      } else {
        alert(`❌ Error: ${errMsg}`);
      }
    }
  };

  const resetFormAndImages = (type) => {
    setSelectedImage(null);
    setSelectedImages([]);
    setImagePreview(null);
    setImagePreviews([]);
    setExistingImages([]);
    setActivityImageUrlInput("");
    setEditFormData({});

    const t = type === "countries" ? "country" : type === "cities" ? "city" : type === "activities" ? "activity" : type === "activity-options" || type === "options" ? "option" : type === "visitor-types" ? "visitor-type" : type;

    switch (t) {
      case "country":
        setNewCountry({
          name: "",
          currency: "INR",
          currencySymbol: "₹",
          active: true,
          imageUrl: "",
        });
        break;
      case "city":
        setNewCity({
          countryId: "",
          name: "",
          timezone: "Asia/Kolkata",
          active: true,
          imageUrl: "",
        });
        break;
      case "activity":
        setNewActivity({
          cityId: "",
          name: "",
          description: "",
          duration: 60,
          maxCapacity: 10,
          status: "active",
        });
        break;
      case "option":
        setNewOption({
          activityId: "",
          name: "",
          basePrice: 0,
          duration: 60,
          maxCapacity: 10,
          includesTransfers: false,
          active: true,
          bookingStartDate: "",
          bookingEndDate: "",
        });
        setNewOptionTimeSlots([]);
        setOptionSelectedCountry("");
        setOptionSelectedCity("");
        break;
      case "visitor-type":
        setNewVisitorType({
          name: "",
          minAge: 0,
          maxAge: 100,
          priceMultiplier: 1.0,
          active: true,
        });
        break;
      case "time-pricing":
        setTimePricingSelectedCountry("");
        setTimePricingSelectedCity("");
        setTimePricingSlots([]);
        setNewTimePricing({
          activityId: "",
          activityOptionId: "",
          days: [],
          timeSlotIds: [],
          multiplier: 1.0,
          label: "",
          active: true,
        });
        break;
    }
  };

  const getNormalizedId = (val) => (val && typeof val === "object" && val._id ? val._id : val);

  const handleUpdate = async (type, id, data, imageFile = null, imageFiles = null) => {
    try {
      const endpoint = `${API_BASE_URL}/api/activity/admin/${type}/${id}`;
      const formData = new FormData();

      switch (type) {
        case "countries":
        case "country":
          formData.append("name", data.name || "");
          formData.append("currency", data.currency || "INR");
          formData.append("currencySymbol", data.currencySymbol || "₹");
          formData.append("active", data.active !== undefined ? data.active : true);
          if (imageFile && typeof imageFile === "object" && imageFile instanceof File) {
            formData.append("image", imageFile);
          } else if (data.imageUrl && String(data.imageUrl).trim().startsWith("http")) {
            formData.append("imageUrl", data.imageUrl.trim());
          } else if (data.image && typeof data.image === "string" && data.image.startsWith("http")) {
            formData.append("imageUrl", data.image);
          }
          await axios.put(endpoint, formData, { withCredentials: true });
          break;
        case "cities":
        case "city": {
          const countryId = getNormalizedId(data.countryId);
          formData.append("countryId", countryId || "");
          formData.append("name", data.name || "");
          formData.append("timezone", data.timezone || "Asia/Kolkata");
          formData.append("active", data.active !== undefined ? data.active : true);
          if (imageFile) {
            formData.append("image", imageFile);
          } else if (data.imageUrl && String(data.imageUrl).trim().startsWith("http")) {
            formData.append("image", data.imageUrl.trim());
          } else if (data.image) {
            formData.append("image", data.image);
          }
          await axios.put(endpoint, formData);
          break;
        }
        case "activities":
        case "activity": {
          const cityId = getNormalizedId(data.cityId);
          formData.append("cityId", cityId || "");
          formData.append("name", data.name || "");
          formData.append("description", data.description || "");
          formData.append("duration", String(data.duration ?? 60));
          formData.append("maxCapacity", String(data.maxCapacity ?? 10));
          formData.append("status", data.status || "active");
          if (existingImages.length > 0) {
            formData.append("existingImages", JSON.stringify(existingImages));
          }
          if (imageFiles && imageFiles.length > 0) {
            imageFiles.forEach((file) => formData.append("images", file));
          }
          await axios.put(endpoint, formData);
          break;
        }
        case "activity-options":
        case "options": {
          const activityId = getNormalizedId(data.activityId);
          const payload = {
            activityId: activityId || data.activityId,
            name: data.name || "",
            basePrice: Number(data.basePrice) || 0,
            duration: Number(data.duration) || 60,
            maxCapacity: Number(data.maxCapacity) || 10,
            allowedVisitorTypeIds: Array.isArray(data.allowedVisitorTypeIds) ? data.allowedVisitorTypeIds : [],
            includesTransfers: data.includesTransfers === true || data.includesTransfers === "true",
            active: data.active !== undefined ? data.active : true,
            bookingStartDate: data.bookingStartDate ? (typeof data.bookingStartDate === "string" ? data.bookingStartDate : new Date(data.bookingStartDate).toISOString().slice(0, 10)) : null,
            bookingEndDate: data.bookingEndDate ? (typeof data.bookingEndDate === "string" ? data.bookingEndDate : new Date(data.bookingEndDate).toISOString().slice(0, 10)) : null,
            advanceBookingDays: data.advanceBookingDays !== undefined && data.advanceBookingDays !== "" ? Number(data.advanceBookingDays) : null,
            pricingTiers: Array.isArray(data.pricingTiers) ? data.pricingTiers : [],
          };
          const putEndpoint = `${API_BASE_URL}/api/activity/admin/activity-options/${id}`;
          await axios.put(putEndpoint, payload);
          break;
        }
        case "visitor-types": {
          const payload = {
            name: data.name || "",
            minAge: Number(data.minAge) ?? 0,
            maxAge: Number(data.maxAge) ?? 100,
            priceMultiplier: Number(data.priceMultiplier) ?? 1,
            active: data.active !== undefined ? data.active : true,
          };
          await axios.put(endpoint, payload);
          break;
        }
        case "time-pricing": {
          const activityId = getNormalizedId(data.activityId);
          const timePricingData = {
            activityId: activityId || data.activityId,
            activityOptionId: data.activityOptionId || null,
            days: data.days || [],
            timeSlotIds: data.timeSlotIds || [],
            multiplier: parseFloat(data.multiplier) || 1,
            label: data.label || "",
            active: data.active !== undefined ? data.active : true,
          };
          await axios.put(endpoint, timePricingData);
          break;
        }
        default:
          await axios.put(endpoint, data);
      }

      alert(`✅ ${String(type).replace(/-/g, " ")} updated successfully!`);
      fetchDashboardData();
      setEditingItem(null);
      setShowAddModal(false);
      resetFormAndImages(type);
    } catch (error) {
      alert(`❌ Error: ${error.response?.data?.error || error.message}`);
    }
  };

  const handleDelete = async (type, id) => {
    if (
      window.confirm(
        `Are you sure you want to delete this ${type.replace("-", " ")}?`
      )
    ) {
      try {
        await axios.delete(`${API_BASE_URL}/api/activity/admin/${type}/${id}`);
        alert(`✅ ${type.replace("-", " ")} deleted successfully!`);
        fetchDashboardData();
      } catch (error) {
        alert(`❌ Error: ${error.response?.data?.error || error.message}`);
      }
    }
  };

  const handleToggleStatus = async (type, id, currentStatus) => {
    try {
      await axios.put(`${API_BASE_URL}/api/activity/admin/${type}/${id}`, {
        active: !currentStatus,
      });
      fetchDashboardData();
    } catch (error) {
      alert(`❌ Error: ${error.response?.data?.error || error.message}`);
    }
  };

  // Image upload handlers
  const handleImageSelect = (e, isMultiple = false) => {
    const files = e.target.files;
    if (isMultiple) {
      const newFiles = Array.from(files);
      setSelectedImages((prev) => [...prev, ...newFiles]);
      const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
      setImagePreviews((prev) => [...prev, ...newPreviews]);
    } else {
      if (files && files[0]) {
        setSelectedImage(files[0]);
        setImagePreview(URL.createObjectURL(files[0]));
      }
    }
  };

  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
    setImagePreviews((prev) => {
      URL.revokeObjectURL(prev[index]);
      return prev.filter((_, i) => i !== index);
    });
  };

  const removeExistingImage = (index) => {
    setExistingImages((prev) => prev.filter((_, i) => i !== index));
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    const cleanPath = imagePath.replace(/\\/g, "/");
    if (cleanPath.startsWith("http")) return cleanPath;
    return `${API_BASE_URL}/${cleanPath}`;
  };

  // Navigation items
  const navItems = [
    { id: "dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
    { id: "countries", label: "Countries", icon: <FaGlobe /> },
    { id: "cities", label: "Cities", icon: <FaCity /> },
    { id: "activities", label: "Activities", icon: <FaUmbrellaBeach /> },
    { id: "options", label: "Options", icon: <FaCog /> },
    // { id: "visitor-types", label: "Visitor Types", icon: <FaUserFriends /> },
    { id: "time-pricing", label: "Time Pricing", icon: <FaClock /> },
    { id: "bookings", label: "Activity Bookings", icon: <FaList /> },
    // { id: "currencies", label: "Currencies", icon: <FaMoneyBillWave /> },
    { id: "reports", label: "Reports", icon: <FaChartPie /> },
  ];

  // Stats cards
  const statCards = [
    {
      label: "Total Countries",
      value: stats.totalCountries,
      icon: <FaGlobe />,
      color: "bg-blue-500",
    },
    {
      label: "Total Cities",
      value: stats.totalCities,
      icon: <FaCity />,
      color: "bg-green-500",
    },
    {
      label: "Total Activities",
      value: stats.totalActivities,
      icon: <FaUmbrellaBeach />,
      color: "bg-purple-500",
    },
    {
      label: "Total Bookings",
      value: stats.totalBookings,
      icon: <FaList />,
      color: "bg-yellow-500",
    },
    {
      label: "Total Revenue",
      value: `$${stats.totalRevenue}`,
      icon: <FaMoneyBillWave />,
      color: "bg-indigo-500",
    },
    {
      label: "Total Users",
      value: stats.totalUsers,
      icon: <FaUsers />,
      color: "bg-pink-500",
    },
  ];

  // Render Dashboard
  const renderDashboard = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Dashboard Overview
          </h2>
          <p className="text-gray-600">Welcome to Activity Management System</p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {statCards.slice(0, 3).map((stat, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm border p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">
                  {stat.label}
                </p>
                <p className="text-2xl font-bold text-gray-900 mt-2">
                  {stat.value}
                </p>
              </div>
              <div className={`${stat.color} p-3 rounded-lg`}>
                <div className="text-white text-xl">{stat.icon}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-xl shadow-sm border p-6">
        <h3 className="text-lg font-bold text-gray-900 mb-4">Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <button
            onClick={() => {
              setModalType("country");
              setNewCountry({ name: "", currency: "INR", currencySymbol: "₹", active: true, imageUrl: "" });
              fetchCountriesOnly();
              setShowAddModal(true);
            }}
            className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 text-center"
          >
            <FaGlobe className="text-blue-500 text-2xl mx-auto mb-2" />
            <span className="font-medium">Add Country</span>
          </button>
          <button
            onClick={() => {
              setModalType("city");
              setShowAddModal(true);
            }}
            className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 text-center"
          >
            <FaCity className="text-green-500 text-2xl mx-auto mb-2" />
            <span className="font-medium">Add City</span>
          </button>
          <button
            onClick={() => {
              setModalType("activity");
              setShowAddModal(true);
            }}
            className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 text-center"
          >
            <FaUmbrellaBeach className="text-purple-500 text-2xl mx-auto mb-2" />
            <span className="font-medium">Add Activity</span>
          </button>
        </div>
      </div>
    </div>
  );

  // Render Countries Management
  const renderCountries = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Countries Management
          </h2>
          <p className="text-gray-600">Manage all countries in the system</p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search countries..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            onClick={() => {
              setModalType("country");
              setNewCountry({ name: "", currency: "INR", currencySymbol: "₹", active: true, imageUrl: "" });
              fetchCountriesOnly();
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add Country
          </button>
        </div>
      </div>

      {/* Countries Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Country
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Currency
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {countries && countries.length > 0 ? (
                countries
                  .filter((c) =>
                    c.name.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((country) => (
                    <tr key={country._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          {country.image ? (
                            <img
                              src={getImageUrl(country.image)}
                              alt={country.name}
                              className="h-10 w-10 rounded-lg object-cover mr-3"
                              onError={(e) => {
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                            />
                          ) : null}
                          <div className={`h-8 w-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3 ${country.image ? "hidden" : ""}`}>
                            <span className="text-sm font-bold text-blue-700">
                              {(country.name || "").substring(0, 2)}
                            </span>
                          </div>
                          <div className="font-medium text-gray-900">
                            {country.name}
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {country.currency}
                        </div>
                        <div className="text-xs text-gray-500">
                          {country.currencySymbol}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${country.active
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                            }`}
                        >
                          {country.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-3">
                          <button
                            onClick={() => {
                              setEditingItem({ ...country, type: "countries" });
                              setEditFormData(country);
                            }}
                            className="text-green-600 hover:text-green-900"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() =>
                              handleDelete("countries", country._id)
                            }
                            className="text-red-600 hover:text-red-900"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No countries found. Add your first country!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // Render Cities Management
  const renderCities = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Cities Management
          </h2>
          <p className="text-gray-600">Manage cities by country</p>
        </div>
        <div className="flex items-center space-x-4 flex-wrap gap-2">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search cities..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <select
            value={countryFilter}
            onChange={(e) => setCountryFilter(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="">All Countries</option>
            {countries.map((country) => (
              <option key={country._id} value={country._id}>
                {country.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              setModalType("city");
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add City
          </button>
        </div>
      </div>

      {/* Cities Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  City
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Country
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Timezone
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {cities && cities.length > 0 ? (
                cities
                  .filter((c) => {
                    // Search filter
                    const matchesSearch = c.name.toLowerCase().includes(searchTerm.toLowerCase());
                    // Country filter
                    const countryId = c.countryId && typeof c.countryId === 'object' ? c.countryId._id : c.countryId;
                    const matchesCountry = !countryFilter || countryId === countryFilter || countryId?.toString() === countryFilter;
                    return matchesSearch && matchesCountry;
                  })
                  .map((city) => {
                    // Handle both populated and non-populated countryId
                    const country = city.countryId && typeof city.countryId === 'object'
                      ? city.countryId
                      : countries.find((co) => co._id === city.countryId || co._id?.toString() === city.countryId?.toString());
                    const countryName = country?.name || (typeof city.countryId === 'object' ? city.countryId?.name : null) || "N/A";

                    return (
                      <tr key={city._id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex items-center">
                            {city.image ? (
                              <img
                                src={getImageUrl(city.image)}
                                alt={city.name}
                                className="h-10 w-10 rounded-lg object-cover mr-3"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div className={`h-8 w-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3 ${city.image ? "hidden" : ""}`}>
                              <FaBuilding className="text-purple-600" />
                            </div>
                            <div className="font-medium text-gray-900">
                              {city.name}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span>{countryName}</span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {city.timezone}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${city.active
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                              }`}
                          >
                            {city.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex items-center space-x-3">
                            <button
                              onClick={() => {
                                setEditingItem({ ...city, type: "cities" });
                                setEditFormData(city);
                              }}
                              className="text-green-600 hover:text-green-900"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() => handleDelete("cities", city._id)}
                              className="text-red-600 hover:text-red-900"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No cities found. Add your first city!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // Render Activities Management
  const renderActivities = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Activities Management
          </h2>
          <p className="text-gray-600">Manage all activities in the system</p>
        </div>
        <div className="flex items-center space-x-4 flex-wrap gap-2">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search activities..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <select
            value={cityFilter}
            onChange={(e) => setCityFilter(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="">All Cities</option>
            {cities.map((city) => (
              <option key={city._id} value={city._id}>
                {city.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              setModalType("activity");
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add Activity
          </button>
        </div>
      </div>

      {/* Activities Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Activity
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  City
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Capacity
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {activities && activities.length > 0 ? (
                activities
                  .filter((a) => {
                    // Search filter
                    const matchesSearch =
                      a.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      (a.description || "")
                        .toLowerCase()
                        .includes(searchTerm.toLowerCase());
                    // City filter
                    const cityId = a.cityId && typeof a.cityId === 'object' ? a.cityId._id : a.cityId;
                    const matchesCity = !cityFilter || cityId === cityFilter || cityId?.toString() === cityFilter;
                    return matchesSearch && matchesCity;
                  })
                  .map((activity) => {
                    // Handle both populated and non-populated cityId
                    const city = activity.cityId && typeof activity.cityId === 'object'
                      ? activity.cityId
                      : cities.find((c) => c._id === activity.cityId || c._id?.toString() === activity.cityId?.toString());
                    const cityName = city?.name || (typeof activity.cityId === 'object' ? activity.cityId?.name : null) || "N/A";

                    return (
                      <tr key={activity._id} className="hover:bg-gray-50">
                        <td className="px-6 py-4">
                          <div className="flex items-center">
                            {activity.images && activity.images.length > 0 ? (
                              <img
                                src={getImageUrl(activity.images[0])}
                                alt={activity.name}
                                className="h-12 w-12 rounded-lg object-cover mr-3"
                                onError={(e) => {
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div className={`h-8 w-8 bg-green-100 rounded-lg flex items-center justify-center mr-3 ${activity.images && activity.images.length > 0 ? "hidden" : ""}`}>
                              <FaUmbrellaBeach className="text-green-600" />
                            </div>
                            <div>
                              <div className="font-medium text-gray-900">
                                {activity.name}
                              </div>
                              <div className="text-sm text-gray-500 truncate max-w-xs">
                                {activity.description}
                              </div>
                              {activity.images && activity.images.length > 1 && (
                                <div className="text-xs text-blue-600 mt-1">
                                  +{activity.images.length - 1} more images
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {cityName}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm">
                            {activity.duration} min
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {activity.maxCapacity}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${activity.status === "active"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                              }`}
                          >
                            {activity.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex items-center space-x-3">
                            <button
                              onClick={() => {
                                setEditingItem({
                                  ...activity,
                                  type: "activities",
                                });
                                setEditFormData(activity);
                              }}
                              className="text-green-600 hover:text-green-900"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() =>
                                handleDelete("activities", activity._id)
                              }
                              className="text-red-600 hover:text-red-900"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No activities found. Add your first activity!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // Render Options Management
  const renderOptions = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Activity Options</h2>
          <p className="text-gray-600">Manage pricing options for activities</p>
        </div>
        <div className="flex items-center space-x-4 flex-wrap gap-2">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search options..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <select
            value={optionCountryFilter}
            onChange={(e) => {
              setOptionCountryFilter(e.target.value);
              setOptionCityFilter(""); // Reset city filter when country changes
              setOptionActivityFilter(""); // Reset activity filter when country changes
            }}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="">All Countries</option>
            {countries.map((country) => (
              <option key={country._id} value={country._id}>
                {country.name}
              </option>
            ))}
          </select>
          <select
            value={optionCityFilter}
            onChange={(e) => {
              setOptionCityFilter(e.target.value);
              setOptionActivityFilter(""); // Reset activity filter when city changes
            }}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            disabled={!optionCountryFilter}
          >
            <option value="">All Cities</option>
            {cities
              .filter((city) => {
                const cityCountryId = city.countryId && typeof city.countryId === 'object'
                  ? city.countryId._id
                  : city.countryId;
                return !optionCountryFilter || cityCountryId === optionCountryFilter || cityCountryId?.toString() === optionCountryFilter;
              })
              .map((city) => (
                <option key={city._id} value={city._id}>
                  {city.name}
                </option>
              ))}
          </select>
          <select
            value={optionActivityFilter}
            onChange={(e) => setOptionActivityFilter(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            disabled={!optionCityFilter}
          >
            <option value="">All Activities</option>
            {activities
              .filter((activity) => {
                const activityCityId = activity.cityId && typeof activity.cityId === 'object'
                  ? activity.cityId._id
                  : activity.cityId;
                return !optionCityFilter || activityCityId === optionCityFilter || activityCityId?.toString() === optionCityFilter;
              })
              .map((activity) => (
                <option key={activity._id} value={activity._id}>
                  {activity.name}
                </option>
              ))}
          </select>
          <button
            onClick={() => {
              setModalType("option");
              setOptionSelectedCountry("");
              setOptionSelectedCity("");
              setNewOptionTimeSlots([]);
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add Option
          </button>
        </div>
      </div>

      {/* Options Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Option
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Country
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  City
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Activity
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Price
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Duration
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Capacity
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Transfers
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {activityOptions && activityOptions.length > 0 ? (
                activityOptions
                  .filter((o) => {
                    // Search filter
                    const matchesSearch = o.name.toLowerCase().includes(searchTerm.toLowerCase());

                    // Get activity, city, and country from populated data
                    const activity = o.activityId && typeof o.activityId === 'object'
                      ? o.activityId
                      : activities.find((a) => a._id === o.activityId || a._id?.toString() === o.activityId?.toString());

                    const city = activity?.cityId && typeof activity.cityId === 'object'
                      ? activity.cityId
                      : (activity ? cities.find((c) => c._id === activity.cityId || c._id?.toString() === activity.cityId?.toString()) : null);

                    const country = city?.countryId && typeof city.countryId === 'object'
                      ? city.countryId
                      : (city ? countries.find((co) => co._id === city.countryId || co._id?.toString() === city.countryId?.toString()) : null);

                    // Country filter
                    const countryId = country?._id || (country && typeof country === 'object' ? country._id : null);
                    const matchesCountry = !optionCountryFilter || countryId === optionCountryFilter || countryId?.toString() === optionCountryFilter;

                    // City filter
                    const cityId = city?._id || (city && typeof city === 'object' ? city._id : null);
                    const matchesCity = !optionCityFilter || cityId === optionCityFilter || cityId?.toString() === optionCityFilter;

                    // Activity filter
                    const activityId = activity?._id || (activity && typeof activity === 'object' ? activity._id : null);
                    const matchesActivity = !optionActivityFilter || activityId === optionActivityFilter || activityId?.toString() === optionActivityFilter;

                    return matchesSearch && matchesCountry && matchesCity && matchesActivity;
                  })
                  .map((option) => {
                    // Handle both populated and non-populated activityId
                    const activity = option.activityId && typeof option.activityId === 'object'
                      ? option.activityId
                      : activities.find((a) => a._id === option.activityId || a._id?.toString() === option.activityId?.toString());

                    const activityName = activity?.name || (typeof option.activityId === 'object' ? option.activityId?.name : null) || "N/A";

                    // Get city from activity
                    const city = activity?.cityId && typeof activity.cityId === 'object'
                      ? activity.cityId
                      : (activity ? cities.find((c) => c._id === activity.cityId || c._id?.toString() === activity.cityId?.toString()) : null);
                    const cityName = city?.name || (typeof activity?.cityId === 'object' ? activity.cityId?.name : null) || "N/A";

                    // Get country from city
                    const country = city?.countryId && typeof city.countryId === 'object'
                      ? city.countryId
                      : (city ? countries.find((co) => co._id === city.countryId || co._id?.toString() === city.countryId?.toString()) : null);
                    const countryName = country?.name || (typeof city?.countryId === 'object' ? city.countryId?.name : null) || "N/A";

                    return (
                      <tr key={option._id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="font-medium text-gray-900">
                            {option.name}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {countryName}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {cityName}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {activityName}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="px-2 py-1 bg-green-100 text-green-800 rounded text-sm font-medium">
                            ₹{option.basePrice}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {option.duration} min
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {option.maxCapacity}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`px-2 py-1 rounded-full text-xs font-medium ${option.includesTransfers ? "bg-teal-100 text-teal-800" : "bg-slate-100 text-slate-600"}`}>
                            {option.includesTransfers ? "With" : "Without"}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${option.active
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                              }`}
                          >
                            {option.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex items-center space-x-3">
                            <button
                              onClick={async () => {
                                setTimeSlotsModalOption(option);
                                setTimeSlotsLoading(true);
                                try {
                                  const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${option._id}`);
                                  setTimeSlotsList(res.data?.data || []);
                                  setNewSlotForm({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" });
                                  setEditingSlotId(null);
                                } catch {
                                  setTimeSlotsList([]);
                                } finally {
                                  setTimeSlotsLoading(false);
                                }
                              }}
                              className="text-blue-600 hover:text-blue-900"
                              title="Manage Time Slots"
                            >
                              <FaClock />
                            </button>
                            <button
                              onClick={() => {
                                setEditingItem({
                                  ...option,
                                  type: "activity-options",
                                });
                                setEditFormData({ ...option, includesTransfers: option.includesTransfers === true });

                                // Extract country and city from populated activity data
                                const activity = option.activityId && typeof option.activityId === 'object'
                                  ? option.activityId
                                  : activities.find((a) => a._id === option.activityId || a._id?.toString() === option.activityId?.toString());

                                if (activity) {
                                  const city = activity.cityId && typeof activity.cityId === 'object'
                                    ? activity.cityId
                                    : cities.find((c) => c._id === activity.cityId || c._id?.toString() === activity.cityId?.toString());

                                  if (city) {
                                    const cityId = city._id || (typeof city === 'string' ? city : null);
                                    if (cityId) {
                                      setOptionSelectedCity(cityId.toString());
                                    }

                                    const country = city.countryId && typeof city.countryId === 'object'
                                      ? city.countryId
                                      : countries.find((co) => co._id === city.countryId || co._id?.toString() === city.countryId?.toString());

                                    if (country) {
                                      const countryId = country._id || (typeof country === 'string' ? country : null);
                                      if (countryId) {
                                        setOptionSelectedCountry(countryId.toString());
                                      }
                                    }
                                  }
                                }
                              }}
                              className="text-green-600 hover:text-green-900"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() =>
                                handleDelete("activity-options", option._id)
                              }
                              className="text-red-600 hover:text-red-900"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td
                    colSpan="10"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No options found. Add your first option!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
  // Render Visitor Types Management
  const renderVisitorTypes = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Visitor Types Management
          </h2>
          <p className="text-gray-600">
            Manage visitor categories and pricing multipliers
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search visitor types..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            onClick={() => {
              setModalType("visitor-type");
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add Visitor Type
          </button>
        </div>
      </div>

      {/* Visitor Types Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Visitor Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Age Range
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Price Multiplier
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {visitorTypes && visitorTypes.length > 0 ? (
                visitorTypes
                  .filter((vt) =>
                    vt.name.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((visitorType) => (
                    <tr key={visitorType._id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="font-medium text-gray-900">
                          {visitorType.name} ({visitorType.minAge}-{visitorType.maxAge})
                        </div>
                        {visitorType.description && (
                          <div className="text-sm text-gray-500">
                            {visitorType.description}
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="text-sm text-gray-600">
                          {visitorType.minAge}-{visitorType.maxAge} years
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="px-3 py-1 bg-green-100 text-green-800 rounded text-sm font-bold">
                          {visitorType.priceMultiplier}x
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-medium ${visitorType.active
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                            }`}
                        >
                          {visitorType.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <div className="flex items-center space-x-3">
                          <button
                            onClick={() => {
                              setEditingItem({
                                ...visitorType,
                                type: "visitor-types",
                              });
                              setEditFormData(visitorType);
                            }}
                            className="text-green-600 hover:text-green-900"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() =>
                              handleDelete("visitor-types", visitorType._id)
                            }
                            className="text-red-600 hover:text-red-900"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No visitor types found. Add your first visitor type!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
  // Render Time Pricing Management
  const renderTimePricing = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Time-Based Pricing
          </h2>
          <p className="text-gray-600">
            Manage dynamic pricing based on time slots
          </p>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search time pricing rules..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <button
            onClick={() => {
              setModalType("time-pricing");
              setShowAddModal(true);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
          >
            <FaPlus className="mr-2" />
            Add Time Pricing Rule
          </button>
        </div>
      </div>

      {/* Time Pricing Table */}
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Activity
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Day Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Time Slot
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Price Multiplier
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Label
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider bg-gray-50">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {timePricing && timePricing.length > 0 ? (
                timePricing
                  .filter((tp) =>
                    tp.label.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((pricing) => {
                    // Handle both populated and non-populated activityId
                    const activity = pricing.activityId && typeof pricing.activityId === 'object'
                      ? pricing.activityId
                      : activities.find((a) => a._id === pricing.activityId || a._id?.toString() === pricing.activityId?.toString());
                    const activityName = activity?.name || (typeof pricing.activityId === 'object' ? pricing.activityId?.name : null) || "N/A";

                    return (
                      <tr key={pricing._id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {activityName}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="flex flex-wrap gap-1 max-w-[150px]">
                            {(pricing.days || []).map((day, idx) => (
                              <span
                                key={idx}
                                className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-blue-100 text-blue-800"
                              >
                                {day.substring(0, 3)}
                              </span>
                            ))}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {pricing.timeSlotIds && pricing.timeSlotIds.length > 0 ? (
                            <div className="flex flex-col gap-1 max-w-[150px]">
                              {pricing.timeSlotIds.map((slot, idx) => (
                                <span key={idx} className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-[10px]">
                                  {slot.startTime} - {slot.endTime}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-sm">All Day</span>
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded text-sm font-bold">
                            {pricing.multiplier}x
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm text-gray-900">
                            {pricing.label}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium ${pricing.active
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                              }`}
                          >
                            {pricing.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex items-center space-x-3">
                            <button
                              onClick={async () => {
                                const actId = pricing.activityId?._id || pricing.activityId;
                                const fullActivity = activities.find(a => a._id === actId);
                                let cId = "";
                                let coId = "";
                                if (fullActivity) {
                                  cId = fullActivity.cityId?._id || fullActivity.cityId;
                                  const fullCity = cities.find(c => c._id === cId);
                                  if (fullCity) {
                                    coId = fullCity.countryId?._id || fullCity.countryId;
                                  }
                                }
                                setTimePricingSelectedCountry(coId);
                                setTimePricingSelectedCity(cId);

                                const optId = pricing.activityOptionId?._id || pricing.activityOptionId;
                                if (optId) {
                                  try {
                                    const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${optId}`);
                                    setTimePricingSlots(res.data?.data || []);
                                  } catch {
                                    setTimePricingSlots([]);
                                  }
                                } else {
                                  setTimePricingSlots([]);
                                }

                                setEditingItem({
                                  ...pricing,
                                  type: "time-pricing",
                                });
                                setEditFormData({
                                  ...pricing,
                                  activityId: actId,
                                  activityOptionId: optId,
                                  timeSlotIds: (pricing.timeSlotIds || []).map(s => s._id || s),
                                });
                              }}
                              className="text-green-600 hover:text-green-900"
                            >
                              <FaEdit />
                            </button>
                            <button
                              onClick={() =>
                                handleDelete("time-pricing", pricing._id)
                              }
                              className="text-red-600 hover:text-red-900"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="px-6 py-8 text-center text-gray-500"
                  >
                    No time pricing rules found. Add your first rule!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
  const renderCurrencies = () => (
    <div className="space-y-6">
      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-blue-900">
        <p className="font-semibold mb-1">Multiplier kaise decide karein?</p>
        <p className="mb-1">Sab prices backend me <strong>INR</strong> me store hote hain. Multiplier = <strong>1 INR is currency me kitna</strong>. Example: 1 INR = 0.012 USD → USD ke liye multiplier <strong>0.012</strong> daalein. INR ke liye multiplier hamesha <strong>1</strong> (base currency).</p>
        <p className="font-semibold mb-1 mt-2">Format kya hai?</p>
        <p>Number dikhane ka tareeka: hazaar ka separator (comma / dot / space) aur decimal ka separator. US style: 1,234.56 | EU style: 1.234,56</p>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Currency Management</h2>
          <p className="text-gray-600">Manage currencies and multipliers for frontend display</p>
        </div>
        <button
          onClick={() => {
            setEditingCurrency(null);
            setCurrencyFormData({ code: "", name: "", symbol: "", multiplier: 1, format: "1,234.56", isBase: false });
            setShowCurrencyModal(true);
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2"
        >
          <FaPlus /> Add Currency
        </button>
      </div>
      <div className="bg-white rounded-xl shadow-md border overflow-hidden">
        <div className="overflow-x-auto max-h-[calc(100vh-240px)] overflow-y-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0 z-10 shadow-xs">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Code</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Name</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Symbol</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Multiplier</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Format</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 uppercase bg-gray-50">Base</th>
                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-700 uppercase bg-gray-50">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {!currencies.length ? (
                <tr>
                  <td colSpan={7} className="px-6 py-8 text-center text-gray-500">No currencies. Add one above.</td>
                </tr>
              ) : (
                currencies.map((c) => (
                  <tr key={c._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap font-medium text-gray-900">{c.code}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600">{c.name}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600">{c.symbol}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600">{c.multiplier}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-gray-600">{c.format || "1,234.56"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{c.isBase ? <span className="text-green-600 font-medium">Yes</span> : "—"}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-right">
                      <button
                        onClick={() => {
                          setEditingCurrency(c);
                          setCurrencyFormData({ code: c.code, name: c.name, symbol: c.symbol, multiplier: c.multiplier, format: c.format || "1,234.56", isBase: !!c.isBase });
                          setShowCurrencyModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-800 mr-3"
                      >
                        Edit
                      </button>
                      <button
                        onClick={async () => {
                          if (!window.confirm("Delete this currency?")) return;
                          try {
                            await axios.delete(`${API_BASE_URL}/api/activity/admin/currencies/${c._id}`);
                            setCurrencies((prev) => prev.filter((x) => x._id !== c._id));
                          } catch (e) {
                            alert(e.response?.data?.error || "Failed to delete");
                          }
                        }}
                        className="text-red-600 hover:text-red-800"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showCurrencyModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4">{editingCurrency ? "Edit Currency" : "Add Currency"}</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Code *</label>
                <input
                  type="text"
                  value={currencyFormData.code}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, code: e.target.value.toUpperCase() }))}
                  placeholder="e.g. INR, USD"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  disabled={!!editingCurrency}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                <input
                  type="text"
                  value={currencyFormData.name}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, name: e.target.value }))}
                  placeholder="e.g. Indian Rupee"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Symbol *</label>
                <input
                  type="text"
                  value={currencyFormData.symbol}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, symbol: e.target.value }))}
                  placeholder="e.g. ₹, $"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Multiplier *</label>
                <p className="text-xs text-gray-500 mb-1">
                  <strong>Kaise decide karein:</strong> Sab prices backend me INR me store hote hain. Multiplier = 1 INR is currency me kitna. Example: 1 INR = 0.012 USD → multiplier <strong>0.012</strong> daalein. 1000 INR = 1000 × 0.012 = 12 USD dikhega. Google pe &quot;1 INR to USD&quot; search karke current rate daal sakte hain.
                </p>
                <input
                  type="number"
                  step="any"
                  min="0"
                  value={currencyFormData.multiplier}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, multiplier: parseFloat(e.target.value) || 0 }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  placeholder="e.g. 0.012 for USD"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Format</label>
                <p className="text-xs text-gray-500 mb-1">
                  <strong>Kya hai:</strong> Number dikhane ka tareeka — hazaar/decimal ka separator. US: comma hazaar, dot decimal (1,234.56). EU: dot hazaar, comma decimal (1.234,56).
                </p>
                <select
                  value={currencyFormData.format}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, format: e.target.value }))}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                >
                  <option value="1,234.56">1,234.56 — US (comma hazaar, dot decimal)</option>
                  <option value="1.234,56">1.234,56 — EU (dot hazaar, comma decimal)</option>
                  <option value="1 234,56">1 234,56 — Space hazaar, comma decimal</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id="isBase"
                  checked={currencyFormData.isBase}
                  onChange={(e) => setCurrencyFormData((p) => ({ ...p, isBase: e.target.checked }))}
                  className="rounded border-gray-300"
                />
                <label htmlFor="isBase" className="text-sm text-gray-700">Base currency (multiplier = 1)</label>
              </div>
            </div>
            <div className="flex gap-3 mt-6">
              <button
                type="button"
                onClick={() => setShowCurrencyModal(false)}
                className="flex-1 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={async () => {
                  try {
                    if (editingCurrency) {
                      await axios.put(`${API_BASE_URL}/api/activity/admin/currencies/${editingCurrency._id}`, {
                        name: currencyFormData.name,
                        symbol: currencyFormData.symbol,
                        multiplier: currencyFormData.multiplier,
                        format: currencyFormData.format,
                        isBase: currencyFormData.isBase,
                      });
                      setCurrencies((prev) => prev.map((x) => (x._id === editingCurrency._id ? { ...x, ...currencyFormData } : x)));
                    } else {
                      const res = await axios.post(`${API_BASE_URL}/api/activity/admin/currencies`, currencyFormData);
                      setCurrencies((prev) => [...prev, res.data.data]);
                    }
                    setShowCurrencyModal(false);
                  } catch (e) {
                    alert(e.response?.data?.error || "Failed to save");
                  }
                }}
                className="flex-1 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                {editingCurrency ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Render Bookings Management
  const renderBookings = () => (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col gap-3 sm:gap-4">
        <div>
          <div className="flex items-center gap-4">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-900">Activity Bookings</h2>
            <button
              onClick={() => setShowCustomModal(true)}
              className="inline-flex items-center gap-2 bg-indigo-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm font-medium text-sm"
            >
              <FiPlus /> Custom Booking
            </button>
          </div>
          <p className="text-sm sm:text-base text-gray-600 mt-0.5">View and manage activity booking requests. Approve or reject and email the customer.</p>
        </div>
        <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-2 sm:gap-3">
          <div className="relative flex-1 min-w-0 sm:max-w-xs">
            <FaSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 w-3.5 h-3.5 sm:w-4 sm:h-4" />
            <input
              type="text"
              placeholder="Search bookings..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-8 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <select
            value={bookingStatusFilter}
            onChange={(e) => setBookingStatusFilter(e.target.value)}
            className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
          >
            <option value="">All status</option>
            <option value="pending">Pending</option>
            <option value="confirmed">Confirmed</option>
            <option value="rejected">Rejected</option>
            <option value="cancelled">Cancelled</option>
            <option value="completed">Completed</option>
          </select>
          <div className="flex gap-2">
            <button type="button" className="px-3 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 flex items-center gap-1.5" onClick={() => { }}>
              <FaFilter className="w-3.5 h-3.5" /> Filter
            </button>
            <button type="button" className="px-3 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-1.5" onClick={() => { }}>
              <FaDownload className="w-3.5 h-3.5" /> Export
            </button>
          </div>
        </div>
      </div>

      {/* Bookings Table - Ant Design: horizontal scroll + 5 rows per page */}
      {(() => {
        const filteredBookingsList = (bookings || []).filter((b) => {
          if (bookingStatusFilter && (b.status || "pending") !== bookingStatusFilter) return false;
          if (!searchTerm.trim()) return true;
          const term = searchTerm.toLowerCase();
          const ref = (b.bookingReference || "").toLowerCase();
          const customer = (b.customerName || b.customerEmail || b.userId?.name || b.userId?.email || "").toLowerCase();
          const activity = (b.activityOptionId?.activityId?.name || "").toLowerCase();
          const city = (b.activityOptionId?.activityId?.cityId?.name || "").toLowerCase();
          const country = (b.activityOptionId?.activityId?.cityId?.countryId?.name || "").toLowerCase();
          return ref.includes(term) || customer.includes(term) || activity.includes(term) || city.includes(term) || country.includes(term);
        });
        const statusClass = (s) =>
          s === "confirmed" || s === "completed" ? "bg-green-100 text-green-800" : s === "cancelled" || s === "rejected" ? "bg-red-100 text-red-800" : "bg-amber-100 text-amber-800";
        const columns = [
          { title: "Ref", dataIndex: "bookingReference", key: "ref", width: 110, ellipsis: true, render: (v) => <span className="font-mono text-gray-900">{v || "—"}</span> },
          {
            title: "Customer",
            key: "customer",
            width: 150,
            render: (_, b) => (
              <div>
                <div className="font-medium text-gray-900 truncate">{b.customerName || b.userId?.name || "Guest"}</div>
                <div className="text-xs text-gray-500 truncate">{b.customerEmail || b.userId?.email || "—"}</div>
              </div>
            ),
          },
          { title: "Phone", dataIndex: "customerPhone", key: "phone", width: 110, ellipsis: true, render: (v) => v || "—" },
          {
            title: "Activity",
            key: "activity",
            width: 160,
            render: (_, b) => {
              if (b.isCustomActivity) {
                return (
                  <div>
                    <div className="font-medium text-gray-900 truncate">
                      {b.customActivityDetails?.activityName || "Custom Activity"}
                      <span className="ml-2 text-[10px] font-bold px-1.5 py-0.5 rounded bg-purple-100 text-purple-700 uppercase">Admin</span>
                    </div>
                    <div className="text-xs text-gray-500 truncate">
                      Custom → {b.customActivityDetails?.cityName || "—"}
                    </div>
                  </div>
                );
              }
              const act = b.activityOptionId?.activityId;
              const city = act?.cityId;
              const opt = b.activityOptionId;
              return (
                <div>
                  <div className="font-medium text-gray-900 truncate">{act?.name || "—"}</div>
                  <div className="text-xs text-gray-500 truncate">{opt?.name || ""} {city?.name ? `→ ${city.name}` : ""}</div>
                </div>
              );
            },
          },
          {
            title: "Date & Time",
            key: "date",
            width: 120,
            render: (_, b) => (b.selectedDateTime ? new Date(b.selectedDateTime).toLocaleString("en-IN", { dateStyle: "short", timeStyle: "short" }) : "—"),
          },
          {
            title: "Guests",
            key: "guests",
            width: 70,
            align: "center",
            render: (_, b) => (Array.isArray(b.visitors) ? b.visitors.reduce((s, v) => s + (v.count || 0), 0) : 0),
          },
          {
            title: "Amount",
            key: "amount",
            width: 100,
            render: (_, b) => <span className="font-semibold text-gray-900">{(b.currency === "INR" ? "₹" : b.currency || "₹")}{Number(b.totalPrice || 0).toLocaleString()}</span>,
          },
          {
            title: "Pay",
            key: "pay",
            width: 80,
            render: (_, b) => (
              <span className={`inline-block px-1.5 py-0.5 text-xs font-medium rounded ${b.paymentMethod === "wallet" ? "bg-emerald-100 text-emerald-800" : "bg-blue-100 text-blue-800"}`}>
                {b.paymentMethod === "wallet" ? "Wallet" : "Card"}
              </span>
            ),
          },
          {
            title: "Status",
            key: "status",
            width: 115,
            render: (_, b) => (
              <select
                value={b.status || "pending"}
                onChange={async (e) => {
                  const newStatus = e.target.value;
                  try {
                    await axios.put(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}/status`, { status: newStatus });
                    setBookings((prev) => prev.map((x) => (x._id === b._id ? { ...x, status: newStatus } : x)));
                  } catch (err) {
                    alert(err.response?.data?.error || "Failed to update status");
                  }
                }}
                className={`text-xs font-medium rounded border-0 cursor-pointer focus:ring-2 focus:ring-blue-400 px-1.5 py-1 ${statusClass(b.status || "pending")}`}
              >
                <option value="pending">Pending</option>
                <option value="confirmed">Confirmed</option>
                <option value="completed">Completed</option>
                <option value="cancelled">Cancelled</option>
                <option value="rejected">Rejected</option>
              </select>
            ),
          },
          {
            title: "Actions",
            key: "actions",
            width: 80,
            fixed: "right",
            render: (_, b) => (
              <div className="flex items-center gap-2">
                <button type="button" onClick={() => setSelectedActivityBooking(b)} className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded transition-colors">
                  <FaEye className="w-3.5 h-3.5 shrink-0" /> View
                </button>
                <button
                  type="button"
                  onClick={async () => {
                    if (window.confirm("Are you sure you want to delete this booking?")) {
                      try {
                        await axios.delete(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}`);
                        setBookings((prev) => prev.filter((x) => x._id !== b._id));
                      } catch (err) {
                        alert(err.response?.data?.error || "Failed to delete booking");
                      }
                    }
                  }}
                  className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-600 hover:text-red-800 hover:bg-red-50 rounded transition-colors"
                >
                  <FaTrash className="w-3.5 h-3.5 shrink-0" /> Delete
                </button>
              </div>
            ),
          },
        ];
        return (
          <div className="bg-white rounded-xl shadow-md border overflow-hidden">
            <Table
              columns={columns}
              dataSource={filteredBookingsList}
              rowKey="_id"
              size="small"
              pagination={{
                pageSize: 5,
                showSizeChanger: true,
                showTotal: (total) => `Total ${total} bookings`,
                pageSizeOptions: ["5", "10", "20", "50"],
              }}
              scroll={{ x: 1000 }}
              locale={{ emptyText: "No activity bookings yet." }}
            />
          </div>
        );
      })()}

      {/* Booking Detail Modal */}
      {selectedActivityBooking && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedActivityBooking(null)}
        >
          <div
            className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900">Booking Details</h3>
              <button
                type="button"
                onClick={() => setSelectedActivityBooking(null)}
                className="p-2 rounded-lg hover:bg-gray-100 text-gray-600"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>
            <div className="p-6 space-y-5">
              {(() => {
                const b = selectedActivityBooking;
                const activity = b.activityOptionId?.activityId;
                const city = activity?.cityId;
                const country = city?.countryId;
                const option = b.activityOptionId;
                const date = b.selectedDateTime ? new Date(b.selectedDateTime) : null;
                const pb = b.priceBreakdown;
                const visitorDetailsList = Array.isArray(b.visitorDetails) ? b.visitorDetails : [];
                const customerName = b.customerName || b.userId?.name || "—";
                const customerEmail = b.customerEmail || b.userId?.email || "—";
                const customerPhone = b.customerPhone || "—";
                const formatAmt = (amt) => `${(b.currency === "INR" ? "₹" : b.currency || "₹")}${Number(amt || 0).toLocaleString()}`;
                return (
                  <>
                    <div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Customer</div>
                      <div className="font-semibold text-gray-900">{customerName}</div>
                      <div className="text-sm text-gray-600">{customerEmail}</div>
                      {customerPhone !== "—" && <div className="text-sm text-gray-600">{customerPhone}</div>}
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Activity & Option</div>
                      <div className="font-semibold text-gray-900">{activity?.name || "—"} • {option?.name || "—"}</div>
                      <div className="text-sm text-gray-600 mt-0.5">{country?.name || ""} {city?.name ? ` → ${city.name}` : ""}</div>
                      {(option?.includesTransfers != null || option?.maxCapacity != null) && (
                        <div className="text-xs text-gray-500 mt-1">
                          {option?.includesTransfers ? "With transfers" : "Without transfers"}
                          {option?.maxCapacity != null && ` · Capacity: ${option.maxCapacity}`}
                          {option?.duration != null && ` · ${option.duration} min`}
                        </div>
                      )}
                    </div>
                    {b.pickupLocation && (
                      <div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Pickup location</div>
                        <div className="font-medium text-gray-900">{b.pickupLocation}</div>
                      </div>
                    )}
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Date & Time</div>
                        <div className="font-medium">{date ? date.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—"}</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Booking Reference</div>
                        <div className="font-mono text-sm font-medium">{b.bookingReference || "—"}</div>
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-2">Visitors & Details</div>
                      <div className="space-y-3">
                        {visitorDetailsList.length === 0 ? (
                          <p className="text-sm text-gray-500">No visitor details stored.</p>
                        ) : (
                          visitorDetailsList.map((vd, vIdx) => (
                            <div key={vIdx} className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                              <div className="font-medium text-gray-900 mb-2">{vd.type || "Visitor"} ({(vd.details || []).length})</div>
                              <ul className="space-y-2">
                                {(vd.details || []).map((d, dIdx) => (
                                  <li key={dIdx} className="text-sm text-gray-700 flex flex-wrap gap-x-4 gap-y-1">
                                    <span><strong>Name:</strong> {d.name || "—"}</span>
                                    {d.phone ? <span><strong>Phone:</strong> {d.phone}</span> : null}
                                    {d.age != null ? <span><strong>Age:</strong> {d.age}</span> : null}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs text-gray-500 uppercase tracking-wide mb-2">Pricing</div>
                      <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 space-y-2">
                        {pb?.breakdown && pb.breakdown.length > 0 ? (
                          <>
                            {pb.breakdown.map((row, idx) => (
                              <div key={idx} className="flex justify-between text-sm">
                                <span className="text-gray-700">{row.type} × {row.count} @ {formatAmt(row.pricePerPerson)}</span>
                                <span className="font-medium">{formatAmt(row.subtotal)}</span>
                              </div>
                            ))}
                            <div className="border-t pt-2 mt-2 flex justify-between font-semibold text-gray-900">
                              <span>Total</span>
                              <span>{formatAmt(pb.total ?? b.totalPrice)}</span>
                            </div>
                          </>
                        ) : (
                          <div className="flex justify-between font-semibold">
                            <span>Total</span>
                            <span>{formatAmt(b.totalPrice)}</span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className={`px-2 py-1 text-xs font-medium rounded ${b.paymentMethod === "wallet" ? "bg-emerald-100 text-emerald-800" : "bg-blue-100 text-blue-800"}`}>
                        {b.paymentMethod === "wallet" ? "Wallet" : "Card"}
                      </span>
                      <span className={`px-2 py-1 text-xs font-medium rounded ${b.status === "confirmed" || b.status === "completed" ? "bg-green-100 text-green-800" :
                        b.status === "cancelled" || b.status === "rejected" ? "bg-red-100 text-red-800" : "bg-amber-100 text-amber-800"
                        }`}>
                        {b.status || "pending"}
                      </span>
                      <div className="ml-auto flex flex-wrap items-center gap-2">
                        {(b.status === "pending" || !b.status) && (
                          <>
                            <button
                              type="button"
                              disabled={bookingStatusUpdating}
                              onClick={async () => {
                                setBookingStatusUpdating(true);
                                try {
                                  await axios.put(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}/status`, { status: "confirmed" });
                                  setBookings((prev) => prev.map((x) => (x._id === b._id ? { ...x, status: "confirmed" } : x)));
                                  setSelectedActivityBooking((prev) => prev && prev._id === b._id ? { ...prev, status: "confirmed" } : prev);
                                } catch (err) {
                                  alert(err.response?.data?.error || "Failed to approve");
                                } finally {
                                  setBookingStatusUpdating(false);
                                }
                              }}
                              className="px-4 py-2 text-sm font-medium rounded-lg bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
                            >
                              {bookingStatusUpdating ? "Updating..." : "Approve"}
                            </button>
                            <button
                              type="button"
                              disabled={bookingStatusUpdating}
                              onClick={async () => {
                                setBookingStatusUpdating(true);
                                try {
                                  await axios.put(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}/status`, { status: "rejected" });
                                  setBookings((prev) => prev.map((x) => (x._id === b._id ? { ...x, status: "rejected" } : x)));
                                  setSelectedActivityBooking((prev) => prev && prev._id === b._id ? { ...prev, status: "rejected" } : prev);
                                } catch (err) {
                                  alert(err.response?.data?.error || "Failed to reject");
                                } finally {
                                  setBookingStatusUpdating(false);
                                }
                              }}
                              className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
                            >
                              Reject
                            </button>
                          </>
                        )}
                        <label className="text-xs text-gray-500 mr-1">Status:</label>
                        <select
                          value={b.status || "pending"}
                          onChange={async (e) => {
                            const newStatus = e.target.value;
                            setBookingStatusUpdating(true);
                            try {
                              await axios.put(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}/status`, { status: newStatus });
                              setBookings((prev) => prev.map((x) => (x._id === b._id ? { ...x, status: newStatus } : x)));
                              setSelectedActivityBooking((prev) => prev && prev._id === b._id ? { ...prev, status: newStatus } : prev);
                            } catch (err) {
                              alert(err.response?.data?.error || "Failed to update status");
                            } finally {
                              setBookingStatusUpdating(false);
                            }
                          }}
                          className="text-sm font-medium rounded border border-gray-300 px-2 py-1.5 focus:ring-2 focus:ring-blue-400"
                        >
                          <option value="pending">Pending</option>
                          <option value="confirmed">Confirmed</option>
                          <option value="completed">Completed</option>
                          <option value="cancelled">Cancelled</option>
                          <option value="rejected">Rejected</option>
                        </select>
                      </div>
                    </div>
                    <div className="pt-3 border-t space-y-3">
                      <div className="flex flex-wrap items-center gap-3">
                        {customerEmail && customerEmail !== "—" && (
                          <button
                            type="button"
                            disabled={confirmationSending}
                            onClick={async () => {
                              setConfirmationSending(true);
                              try {
                                await axios.post(`${API_BASE_URL}/api/activity/admin/bookings/${b._id}/send-confirmation`);
                                alert("Confirmation email sent (with e-ticket if uploaded).");
                              } catch (err) {
                                alert(err.response?.data?.error || "Failed to send email.");
                              } finally {
                                setConfirmationSending(false);
                              }
                            }}
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-emerald-100 text-emerald-800 font-medium hover:bg-emerald-200 disabled:opacity-50"
                          >
                            <FaPaperPlane className="w-4 h-4" />
                            {confirmationSending ? "Sending…" : "Send confirmation email"}
                          </button>
                        )}
                      </div>
                      {customerEmail && customerEmail !== "—" && (
                        <a
                          href={`mailto:${customerEmail}?subject=Activity Booking ${(b.status === "confirmed" || b.status === "completed") ? "Confirmed" : b.status === "rejected" || b.status === "cancelled" ? "Update" : "Request"}`}
                          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-100 text-blue-800 font-medium hover:bg-blue-200"
                        >
                          Email customer
                        </a>
                      )}
                    </div>

                    <div className="mt-4 border-t pt-4">
                      <AdminDocumentViewer adminDocuments={b.adminDocuments} />
                      <AdminDocumentUploader
                        type="activity"
                        bookingId={b._id}
                        onUploadSuccess={(updatedDocs) => {
                          setSelectedActivityBooking((prev) => ({ ...prev, adminDocuments: updatedDocs }));
                          setBookings((prev) => prev.map((x) => (x._id === b._id ? { ...x, adminDocuments: updatedDocs } : x)));
                        }}
                      />
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Render Reports (Placeholder)
  const renderReports = () => (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Reports & Analytics
          </h2>
          <p className="text-gray-600">
            View system analytics and generate reports
          </p>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md border p-8 text-center">
        <FaChartPie className="text-4xl text-gray-400 mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Reports Feature Coming Soon
        </h3>
        <p className="text-gray-600">
          The reporting and analytics system will be available in the next
          update.
        </p>
      </div>
    </div>
  );

  // Initialize existing images when editing activity
  useEffect(() => {
    if (editingItem && editingItem.type === "activity" && editFormData.images && Array.isArray(editFormData.images)) {
      setExistingImages(editFormData.images);
    } else if (!editingItem) {
      setExistingImages([]);
    }
  }, [editingItem, editFormData.images]);

  // Render Modal
  const renderModal = () => {
    if (!showAddModal && !editingItem) return null;

    const isEdit = !!editingItem;
    const apiType = isEdit ? editingItem.type : modalType;
    const formTypeMap = {
      countries: "country",
      cities: "city",
      activities: "activity",
      "activity-options": "option",
      "visitor-types": "visitor-type",
      "time-pricing": "time-pricing",
    };
    const formType = isEdit ? (formTypeMap[apiType] || apiType) : modalType;
    const type = formType;

    // Get form data based on type
    let formData;
    if (isEdit) {
      formData = editFormData;
    } else {
      switch (type) {
        case "country":
          formData = newCountry;
          break;
        case "city":
          formData = newCity;
          break;
        case "activity":
          formData = newActivity;
          break;
        case "option":
          formData = newOption;
          break;
        case "visitor-type":
          formData = newVisitorType;
          break;
        case "time-pricing":
          formData = newTimePricing;
          break;
        default:
          formData = {};
      }
    }

    const handleFormChange = (field, value) => {
      if (isEdit) {
        setEditFormData((prev) => ({ ...prev, [field]: value }));
      } else {
        switch (type) {
          case "country":
            setNewCountry((prev) => ({ ...prev, [field]: value }));
            break;
          case "city":
            setNewCity((prev) => ({ ...prev, [field]: value }));
            break;
          case "activity":
            setNewActivity((prev) => ({ ...prev, [field]: value }));
            break;
          case "option":
            setNewOption((prev) => ({ ...prev, [field]: value }));
            break;
          case "visitor-type":
            setNewVisitorType((prev) => ({ ...prev, [field]: value }));
            break;
          case "time-pricing":
            setNewTimePricing((prev) => ({ ...prev, [field]: value }));
            break;
        }
      }
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      if (isEdit) {
        handleUpdate(apiType, editingItem._id, formData, selectedImage, selectedImages);
      } else {
        // Prevent duplicate country name before calling API
        if (type === "country" && (formData.name || "").trim()) {
          const nameExists = (countries || []).some(
            (c) => (c.name || "").trim().toLowerCase() === (formData.name || "").trim().toLowerCase()
          );
          if (nameExists) {
            alert("A country with this name already exists. Please use a different name or edit the existing country.");
            return;
          }
        }
        handleCreate(type, formData, selectedImage, selectedImages);
      }
    };

    const getModalTitle = () => {
      const titles = {
        country: "Country",
        city: "City",
        activity: "Activity",
        option: "Activity Option",
        "visitor-type": "Visitor Type",
        "time-pricing": "Time Pricing",
      };
      return `${isEdit ? "Edit" : "Add New"} ${titles[type] || type}`;
    };

    const renderFormFields = () => {
      switch (type) {
        case "country":
          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Country Name *
                </label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Currency *
                </label>
                <input
                  type="text"
                  value={formData.currency || ""}
                  onChange={(e) => handleFormChange("currency", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Currency Symbol *
                </label>
                <input
                  type="text"
                  value={formData.currencySymbol || ""}
                  onChange={(e) =>
                    handleFormChange("currencySymbol", e.target.value)
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Country Image
                </label>
                <div className="space-y-4">
                  {(imagePreview || (isEdit && formData.image)) && (
                    <div className="relative">
                      <img
                        src={imagePreview || getImageUrl(formData.image)}
                        alt="Preview"
                        className="w-full h-48 object-cover rounded-lg border border-gray-300"
                      />
                      {imagePreview && (
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedImage(null);
                            setImagePreview(null);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
                        >
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageSelect(e, false)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <p className="text-xs text-gray-500 mt-2">Or paste image URL (permanent link)</p>
                  <input
                    type="url"
                    value={formData.imageUrl ?? (formData.image && String(formData.image).startsWith("http") ? formData.image : "")}
                    onChange={(e) => handleFormChange("imageUrl", e.target.value)}
                    placeholder="https://example.com/image.jpg"
                    className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                  <p className="text-xs text-gray-500">
                    Upload an image or use a URL (JPG, PNG, etc.)
                  </p>
                </div>
              </div>
            </>
          );

        case "city":
          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Country *
                </label>
                <select
                  value={(formData.countryId && typeof formData.countryId === "object" ? formData.countryId._id : formData.countryId) || ""}
                  onChange={(e) =>
                    handleFormChange("countryId", e.target.value)
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country._id} value={country._id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City Name *
                </label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Timezone *
                </label>
                <input
                  type="text"
                  value={formData.timezone || ""}
                  onChange={(e) => handleFormChange("timezone", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City Image
                </label>
                <div className="space-y-4">
                  {(imagePreview || (isEdit && formData.image)) && (
                    <div className="relative">
                      <img
                        src={imagePreview || getImageUrl(formData.image)}
                        alt="Preview"
                        className="w-full h-48 object-cover rounded-lg border border-gray-300"
                      />
                      {imagePreview && (
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedImage(null);
                            setImagePreview(null);
                          }}
                          className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600"
                        >
                          <FaTimes />
                        </button>
                      )}
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleImageSelect(e, false)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <p className="text-xs text-gray-500 mt-2">Or paste image URL (permanent link)</p>
                  <input
                    type="url"
                    value={formData.imageUrl ?? (formData.image && String(formData.image).startsWith("http") ? formData.image : "")}
                    onChange={(e) => handleFormChange("imageUrl", e.target.value)}
                    placeholder="https://example.com/image.jpg"
                    className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                  <p className="text-xs text-gray-500">
                    Upload an image or use a URL (JPG, PNG, etc.)
                  </p>
                </div>
              </div>
            </>
          );

        case "activity":
          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City *
                </label>
                <select
                  value={(formData.cityId && typeof formData.cityId === "object" ? formData.cityId._id : formData.cityId) || ""}
                  onChange={(e) => handleFormChange("cityId", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Activity Name *
                </label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description *
                </label>
                <textarea
                  value={formData.description || ""}
                  onChange={(e) =>
                    handleFormChange("description", e.target.value)
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duration (minutes) *
                </label>
                <input
                  type="number"
                  value={formData.duration || ""}
                  onChange={(e) =>
                    handleFormChange("duration", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="1"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Max Capacity *
                </label>
                <input
                  type="number"
                  value={formData.maxCapacity || ""}
                  onChange={(e) =>
                    handleFormChange("maxCapacity", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="1"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Activity Images (up to 5 images)
                </label>
                <div className="space-y-4">
                  {/* Existing Images */}
                  {existingImages.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                      {existingImages.map((img, idx) => (
                        <div key={idx} className="relative">
                          <img
                            src={getImageUrl(img)}
                            alt={`Existing ${idx + 1}`}
                            className="w-full h-32 object-cover rounded-lg border border-gray-300"
                          />
                          <button
                            type="button"
                            onClick={() => removeExistingImage(idx)}
                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
                          >
                            <FaTimes size={12} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* New Image Previews */}
                  {imagePreviews.length > 0 && (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                      {imagePreviews.map((preview, idx) => (
                        <div key={idx} className="relative">
                          <img
                            src={preview}
                            alt={`Preview ${idx + 1}`}
                            className="w-full h-32 object-cover rounded-lg border border-gray-300"
                          />
                          <button
                            type="button"
                            onClick={() => removeImage(idx)}
                            className="absolute top-2 right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600"
                          >
                            <FaTimes size={12} />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => handleImageSelect(e, true)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    disabled={imagePreviews.length + existingImages.length >= 5}
                  />
                  <p className="text-xs text-gray-500 mt-2">Or paste image URL and click Add</p>
                  <div className="flex gap-2">
                    <input
                      type="url"
                      value={activityImageUrlInput}
                      onChange={(e) => setActivityImageUrlInput(e.target.value)}
                      placeholder="https://example.com/image.jpg"
                      className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                      disabled={imagePreviews.length + existingImages.length >= 5}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const url = activityImageUrlInput.trim();
                        if (url.startsWith("http") && imagePreviews.length + existingImages.length < 5) {
                          setExistingImages((prev) => [...prev, url]);
                          setActivityImageUrlInput("");
                        }
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
                      disabled={imagePreviews.length + existingImages.length >= 5}
                    >
                      Add URL
                    </button>
                  </div>
                  <p className="text-xs text-gray-500">
                    Upload up to 5 images or add URLs (JPG, PNG, etc.)
                    {imagePreviews.length + existingImages.length > 0 && (
                      <span className="ml-2">
                        ({imagePreviews.length + existingImages.length}/5)
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </>
          );

        case "option":
          // Get filtered cities based on selected country
          const filteredCitiesForOption = cities.filter((city) => {
            const cityCountryId = city.countryId && typeof city.countryId === 'object'
              ? city.countryId._id
              : city.countryId;
            return !optionSelectedCountry || cityCountryId === optionSelectedCountry || cityCountryId?.toString() === optionSelectedCountry;
          });

          // Get filtered activities based on selected city
          const filteredActivitiesForOption = activities.filter((activity) => {
            const activityCityId = activity.cityId && typeof activity.cityId === 'object'
              ? activity.cityId._id
              : activity.cityId;
            return !optionSelectedCity || activityCityId === optionSelectedCity || activityCityId?.toString() === optionSelectedCity;
          });

          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Country *
                </label>
                <select
                  value={optionSelectedCountry || ""}
                  onChange={(e) => {
                    setOptionSelectedCountry(e.target.value);
                    setOptionSelectedCity(""); // Reset city when country changes
                    handleFormChange("activityId", ""); // Reset activity when country changes
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country._id} value={country._id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City *
                </label>
                <select
                  value={optionSelectedCity || ""}
                  onChange={(e) => {
                    setOptionSelectedCity(e.target.value);
                    handleFormChange("activityId", ""); // Reset activity when city changes
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  disabled={!optionSelectedCountry}
                >
                  <option value="">Select City</option>
                  {filteredCitiesForOption.map((city) => (
                    <option key={city._id} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Activity *
                </label>
                <select
                  value={(formData.activityId && typeof formData.activityId === "object" ? formData.activityId._id : formData.activityId) || ""}
                  onChange={(e) =>
                    handleFormChange("activityId", e.target.value)
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                  disabled={!optionSelectedCity}
                >
                  <option value="">Select Activity</option>
                  {filteredActivitiesForOption.map((activity) => (
                    <option key={activity._id} value={activity._id}>
                      {activity.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Option Name *
                </label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Base Price (₹) *
                </label>
                <input
                  type="number"
                  value={formData.basePrice || ""}
                  onChange={(e) =>
                    handleFormChange("basePrice", parseFloat(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="0"
                  step="0.01"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Duration (minutes) *
                </label>
                <input
                  type="number"
                  value={formData.duration || ""}
                  onChange={(e) =>
                    handleFormChange("duration", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="1"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Max Capacity *
                </label>
                <input
                  type="number"
                  value={formData.maxCapacity || ""}
                  onChange={(e) =>
                    handleFormChange("maxCapacity", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="1"
                  required
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Pricing Tiers (optional)
                </label>
                <p className="text-xs text-gray-500 mb-2">Add explicit pricing for different visitor types (e.g. Adult, Child). If empty, the global Visitor Types will be used.</p>
                <div className="space-y-3 border border-gray-200 rounded-lg p-4 bg-gray-50">
                  {(formData.pricingTiers || []).map((tier, idx) => (
                    <div key={idx} className="flex flex-wrap gap-3 items-center bg-white p-3 rounded border border-gray-200">
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Type (e.g. Child)</label>
                        <input
                          type="text"
                          value={tier.type || ""}
                          onChange={(e) => {
                            const next = [...(formData.pricingTiers || [])];
                            next[idx] = { ...next[idx], type: e.target.value };
                            handleFormChange("pricingTiers", next);
                          }}
                          className="w-32 px-2 py-1.5 border rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Min Age</label>
                        <input
                          type="number"
                          value={tier.minAge ?? 0}
                          onChange={(e) => {
                            const next = [...(formData.pricingTiers || [])];
                            next[idx] = { ...next[idx], minAge: parseInt(e.target.value) || 0 };
                            handleFormChange("pricingTiers", next);
                          }}
                          className="w-20 px-2 py-1.5 border rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Max Age</label>
                        <input
                          type="number"
                          value={tier.maxAge ?? 100}
                          onChange={(e) => {
                            const next = [...(formData.pricingTiers || [])];
                            next[idx] = { ...next[idx], maxAge: parseInt(e.target.value) || 0 };
                            handleFormChange("pricingTiers", next);
                          }}
                          className="w-20 px-2 py-1.5 border rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Is Paid?</label>
                        <select
                          value={tier.isPaid ? "true" : "false"}
                          onChange={(e) => {
                            const next = [...(formData.pricingTiers || [])];
                            next[idx] = { ...next[idx], isPaid: e.target.value === "true" };
                            handleFormChange("pricingTiers", next);
                          }}
                          className="w-24 px-2 py-1.5 border rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                          <option value="true">Yes</option>
                          <option value="false">No (Free)</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs text-gray-500 mb-1">Price (₹)</label>
                        <input
                          type="number"
                          value={tier.price ?? 0}
                          onChange={(e) => {
                            const next = [...(formData.pricingTiers || [])];
                            next[idx] = { ...next[idx], price: parseFloat(e.target.value) || 0 };
                            handleFormChange("pricingTiers", next);
                          }}
                          disabled={!tier.isPaid}
                          className="w-28 px-2 py-1.5 border rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none disabled:bg-gray-100 disabled:text-gray-400"
                        />
                      </div>
                      <button
                        type="button"
                        onClick={() => {
                          const next = (formData.pricingTiers || []).filter((_, i) => i !== idx);
                          handleFormChange("pricingTiers", next);
                        }}
                        className="mt-5 px-2 py-1 text-red-600 hover:bg-red-50 rounded text-sm"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      const next = [...(formData.pricingTiers || []), { type: "Child", minAge: 2, maxAge: 12, isPaid: true, price: 0 }];
                      handleFormChange("pricingTiers", next);
                    }}
                    className="flex items-center gap-2 px-3 py-2 border border-blue-300 text-blue-700 rounded-lg hover:bg-blue-50 text-sm font-medium"
                  >
                    <FaPlus className="w-4 h-4" />
                    Add Pricing Tier
                  </button>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Booking date range (optional)
                </label>
                <p className="text-xs text-gray-500 mb-2">Users can book this option only within these dates. Leave empty for no restriction.</p>
                <div className="flex flex-wrap gap-4 items-center">
                  <div className="flex-1 min-w-[140px]">
                    <label className="block text-xs text-gray-500 mb-1">From</label>
                    <input
                      type="date"
                      value={formData.bookingStartDate ? (typeof formData.bookingStartDate === "string" && formData.bookingStartDate.length === 10 ? formData.bookingStartDate : new Date(formData.bookingStartDate).toISOString().slice(0, 10)) : ""}
                      onChange={(e) => handleFormChange("bookingStartDate", e.target.value || "")}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="flex-1 min-w-[140px]">
                    <label className="block text-xs text-gray-500 mb-1">To</label>
                    <input
                      type="date"
                      value={formData.bookingEndDate ? (typeof formData.bookingEndDate === "string" && formData.bookingEndDate.length === 10 ? formData.bookingEndDate : new Date(formData.bookingEndDate).toISOString().slice(0, 10)) : ""}
                      onChange={(e) => handleFormChange("bookingEndDate", e.target.value || "")}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Advance Booking Days (optional)
                </label>
                <p className="text-xs text-gray-500 mb-2">Restrict users to book dates only after this many days from the current date. Leave empty for no restriction.</p>
                <input
                  type="number"
                  min="0"
                  value={formData.advanceBookingDays || ""}
                  onChange={(e) => handleFormChange("advanceBookingDays", e.target.value === "" ? "" : Number(e.target.value))}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all hover:border-gray-400 bg-white shadow-sm"
                  placeholder="e.g. 5"
                />
              </div>
              {!isEdit && (
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Time Slots (optional)
                  </label>
                  <p className="text-xs text-gray-500 mb-2">Add fixed time slots for this option. Visitors will pick a slot instead of a free time. Same idea as booking date range above.</p>
                  <div className="space-y-3 border border-gray-200 rounded-lg p-4 bg-gray-50">
                    {(newOptionTimeSlots || []).map((row, idx) => (
                      <div key={idx} className="flex flex-wrap gap-3 items-center bg-white p-3 rounded border border-gray-200">
                        <div>
                          <label className="block text-xs text-gray-500 mb-1">Start</label>
                          <input
                            type="text"
                            value={row.startTime || ""}
                            onChange={(e) => setNewOptionTimeSlots((prev) => {
                              const next = [...(prev || [])];
                              if (!next[idx]) next[idx] = { startTime: "10:00", endTime: "11:00", capacity: 10, label: "" };
                              next[idx] = { ...next[idx], startTime: e.target.value };
                              return next;
                            })}
                            placeholder="10:00"
                            className="w-24 px-2 py-1.5 border rounded text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-500 mb-1">End</label>
                          <input
                            type="text"
                            value={row.endTime || ""}
                            onChange={(e) => setNewOptionTimeSlots((prev) => {
                              const next = [...(prev || [])];
                              if (!next[idx]) next[idx] = { startTime: "10:00", endTime: "11:00", capacity: 10, label: "" };
                              next[idx] = { ...next[idx], endTime: e.target.value };
                              return next;
                            })}
                            placeholder="11:00"
                            className="w-24 px-2 py-1.5 border rounded text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-500 mb-1">Capacity</label>
                          <input
                            type="number"
                            min={1}
                            value={row.capacity ?? 10}
                            onChange={(e) => setNewOptionTimeSlots((prev) => {
                              const next = [...(prev || [])];
                              if (!next[idx]) next[idx] = { startTime: "10:00", endTime: "11:00", capacity: 10, label: "" };
                              next[idx] = { ...next[idx], capacity: parseInt(e.target.value, 10) || 1 };
                              return next;
                            })}
                            className="w-20 px-2 py-1.5 border rounded text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-xs text-gray-500 mb-1">Label</label>
                          <input
                            type="text"
                            value={row.label || ""}
                            onChange={(e) => setNewOptionTimeSlots((prev) => {
                              const next = [...(prev || [])];
                              if (!next[idx]) next[idx] = { startTime: "10:00", endTime: "11:00", capacity: 10, label: "" };
                              next[idx] = { ...next[idx], label: e.target.value };
                              return next;
                            })}
                            placeholder="e.g. Morning"
                            className="w-28 px-2 py-1.5 border rounded text-sm"
                          />
                        </div>
                        <button
                          type="button"
                          onClick={() => setNewOptionTimeSlots((prev) => (prev || []).filter((_, i) => i !== idx))}
                          className="mt-5 px-2 py-1 text-red-600 hover:bg-red-50 rounded text-sm"
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                    <button
                      type="button"
                      onClick={() => setNewOptionTimeSlots((prev) => [...(prev || []), { startTime: "10:00", endTime: "11:00", capacity: 10, label: "" }])}
                      className="flex items-center gap-2 px-3 py-2 border border-blue-300 text-blue-700 rounded-lg hover:bg-blue-50 text-sm font-medium"
                    >
                      <FaPlus className="w-4 h-4" />
                      Add time slot
                    </button>
                  </div>
                </div>
              )}
              {/* 
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Transfers
                </label>
                <div className="flex items-center gap-2 p-3 border border-gray-200 rounded-lg bg-gray-50">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={!!formData.includesTransfers}
                      onChange={(e) => handleFormChange("includesTransfers", e.target.checked)}
                      className="rounded border-gray-300"
                    />
                    <span className="text-sm font-medium text-gray-700">With Transfers</span>
                  </label>
                  <span className="text-xs text-gray-500">Tick if this option includes hotel/venue transfers</span>
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Allowed Visitor Types
                </label>
                <p className="text-xs text-gray-500 mb-2">Leave empty for all types. Select specific types to restrict this option.</p>
                <div className="flex flex-wrap gap-2 p-3 border border-gray-200 rounded-lg bg-gray-50">
                  {visitorTypes.map((vt) => {
                    const ids = formData.allowedVisitorTypeIds || [];
                    const arr = Array.isArray(ids) ? ids : [];
                    const idVal = vt._id?.toString ? vt._id.toString() : vt._id;
                    const isChecked = arr.some((x) => (x && x.toString ? x.toString() : x) === idVal);
                    return (
                      <label key={vt._id} className="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-lg cursor-pointer hover:bg-blue-50">
                        <input
                          type="checkbox"
                          checked={!!isChecked}
                          onChange={(e) => {
                            const next = e.target.checked
                              ? [...arr.filter((x) => (x && x.toString ? x.toString() : x) !== idVal), vt._id]
                              : arr.filter((x) => (x && x.toString ? x.toString() : x) !== idVal);
                            handleFormChange("allowedVisitorTypeIds", next);
                          }}
                          className="rounded border-gray-300"
                        />
                        <span className="text-sm">{vt.name} ({vt.minAge}-{vt.maxAge})</span>
                      </label>
                    );
                  })}
                  {(!visitorTypes || visitorTypes.length === 0) && (
                    <span className="text-sm text-gray-500">No visitor types. Add in Visitor Types section.</span>
                  )}
                </div>
              </div>
              */}
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={formData.description || ""}
                  onChange={(e) =>
                    handleFormChange("description", e.target.value)
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                />
              </div>
              {isEdit && editingItem && editingItem._id && (
                <div className="md:col-span-2 flex flex-wrap items-center gap-3 p-4 border border-blue-200 rounded-lg bg-blue-50">
                  <FaClock className="w-5 h-5 text-blue-600 shrink-0" />
                  <div>
                    <p className="text-sm font-medium text-blue-900">Time Slots</p>
                    <p className="text-xs text-blue-800 mt-0.5">Add or edit time slots for this option. Users will see these when booking.</p>
                  </div>
                  <button
                    type="button"
                    onClick={async () => {
                      const option = editingItem;
                      if (!option || !option._id) return;
                      setTimeSlotsModalOption({ _id: option._id, name: option.name || "Option" });
                      setTimeSlotsLoading(true);
                      setNewSlotForm({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" });
                      setEditingSlotId(null);
                      try {
                        const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${option._id}`);
                        setTimeSlotsList(res.data?.data || []);
                      } catch {
                        setTimeSlotsList([]);
                      } finally {
                        setTimeSlotsLoading(false);
                      }
                    }}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
                  >
                    <FaClock />
                    Manage Time Slots
                  </button>
                </div>
              )}
            </>
          );

        case "time-pricing":
          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Country *</label>
                <select
                  value={timePricingSelectedCountry}
                  onChange={(e) => {
                    setTimePricingSelectedCountry(e.target.value);
                    setTimePricingSelectedCity("");
                    handleFormChange("activityId", "");
                    handleFormChange("activityOptionId", "");
                    setTimePricingSlots([]);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((c) => (
                    <option key={c._id} value={c._id}>{c.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">City *</label>
                <select
                  value={timePricingSelectedCity}
                  onChange={(e) => {
                    setTimePricingSelectedCity(e.target.value);
                    handleFormChange("activityId", "");
                    handleFormChange("activityOptionId", "");
                    setTimePricingSlots([]);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={!timePricingSelectedCountry}
                  required
                >
                  <option value="">Select City</option>
                  {cities
                    .filter((c) => (c.countryId?._id || c.countryId) === timePricingSelectedCountry)
                    .map((city) => (
                    <option key={city._id} value={city._id}>{city.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Activity *
                </label>
                <select
                  value={(formData.activityId && typeof formData.activityId === "object" ? formData.activityId._id : formData.activityId) || ""}
                  onChange={(e) => {
                    handleFormChange("activityId", e.target.value);
                    handleFormChange("activityOptionId", "");
                    setTimePricingSlots([]);
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={!timePricingSelectedCity}
                  required
                >
                  <option value="">Select Activity</option>
                  {activities
                    .filter((a) => (a.cityId?._id || a.cityId) === timePricingSelectedCity)
                    .map((activity) => (
                    <option key={activity._id} value={activity._id}>
                      {activity.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Option *</label>
                <select
                  value={(formData.activityOptionId && typeof formData.activityOptionId === "object" ? formData.activityOptionId._id : formData.activityOptionId) || ""}
                  onChange={async (e) => {
                    const optId = e.target.value || null;
                    handleFormChange("activityOptionId", optId);
                    if (optId) {
                      try {
                        const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${optId}`);
                        setTimePricingSlots(res.data?.data || []);
                      } catch {
                        setTimePricingSlots([]);
                      }
                    } else {
                      setTimePricingSlots([]);
                    }
                  }}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  disabled={!((formData.activityId && typeof formData.activityId === "object" ? formData.activityId._id : formData.activityId) || "")}
                  required
                >
                  <option value="">Select Option</option>
                  {activityOptions
                    .filter((o) => (o.activityId && (o.activityId._id || o.activityId).toString()) === ((formData.activityId && typeof formData.activityId === "object" ? formData.activityId._id : formData.activityId) || "").toString())
                    .map((opt) => <option key={opt._id} value={opt._id}>{opt.name}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Days *
                </label>
                <div className="flex flex-wrap gap-2">
                  {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {
                    const isChecked = (formData.days || []).includes(day);
                    return (
                      <label key={day} className="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-lg cursor-pointer hover:bg-blue-50">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(e) => {
                            const currentDays = formData.days || [];
                            if (e.target.checked) {
                              handleFormChange("days", [...currentDays, day]);
                            } else {
                              handleFormChange("days", currentDays.filter(d => d !== day));
                            }
                          }}
                          className="rounded border-gray-300"
                        />
                        <span className="text-sm">{day}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Time Slots (Optional)
                </label>
                {timePricingSlots.length === 0 ? (
                  <p className="text-sm text-gray-500">No time slots available for this option.</p>
                ) : (
                  <div className="flex flex-wrap gap-2">
                    {timePricingSlots.map((slot) => {
                      const currentSlots = formData.timeSlotIds || [];
                      const slotId = typeof slot === "object" ? slot._id : slot;
                      const isChecked = currentSlots.some(s => (s._id || s) === slotId);

                      return (
                        <label key={slotId} className="flex items-center gap-2 px-3 py-1.5 bg-white border rounded-lg cursor-pointer hover:bg-blue-50">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleFormChange("timeSlotIds", [...currentSlots, slotId]);
                              } else {
                                handleFormChange("timeSlotIds", currentSlots.filter(s => (s._id || s) !== slotId));
                              }
                            }}
                            className="rounded border-gray-300"
                          />
                          <span className="text-sm">
                            {slot.startTime} - {slot.endTime} {slot.label ? `(${slot.label})` : ""}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                )}
                <p className="text-xs text-gray-500 mt-1">If no time slots are selected, the pricing rule will apply all day.</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Price Multiplier *
                </label>
                <input
                  type="number"
                  value={formData.multiplier || 1.0}
                  onChange={(e) =>
                    handleFormChange("multiplier", parseFloat(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="0.1"
                  step="0.1"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  1.0 = Normal price, 1.5 = 50% extra, 0.8 = 20% discount
                </p>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Label/Name *
                </label>
                <input
                  type="text"
                  value={formData.label || ""}
                  onChange={(e) => handleFormChange("label", e.target.value)}
                  placeholder="e.g., Peak Hours, Morning Slot, Evening Discount"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </>
          );
        case "visitor-type":
          return (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Visitor Type Name *
                </label>
                <input
                  type="text"
                  value={formData.name || ""}
                  onChange={(e) => handleFormChange("name", e.target.value)}
                  placeholder="e.g., Adult, Child, Senior"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Minimum Age *
                </label>
                <input
                  type="number"
                  value={formData.minAge || ""}
                  onChange={(e) =>
                    handleFormChange("minAge", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="0"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Maximum Age *
                </label>
                <input
                  type="number"
                  value={formData.maxAge || ""}
                  onChange={(e) =>
                    handleFormChange("maxAge", parseInt(e.target.value))
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="0"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Price Multiplier *
                </label>
                <input
                  type="number"
                  value={formData.priceMultiplier || ""}
                  onChange={(e) =>
                    handleFormChange(
                      "priceMultiplier",
                      parseFloat(e.target.value)
                    )
                  }
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  min="0.1"
                  step="0.1"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  1.0 = Normal price, 0.5 = Half price, 1.5 = 50% more
                </p>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={formData.description || ""}
                  onChange={(e) =>
                    handleFormChange("description", e.target.value)
                  }
                  placeholder="Optional description"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                />
              </div>
            </>
          );
        default:
          return (
            <div className="text-center py-8">
              <p className="text-gray-500">
                Form for {type} will be implemented in the next update
              </p>
            </div>
          );
      }
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <div className="px-6 py-4 border-b flex justify-between items-center">
            <h3 className="text-lg font-bold text-gray-900">
              {getModalTitle()}
            </h3>
            <button
              onClick={() => {
                setShowAddModal(false);
                setEditingItem(null);
                setEditFormData({});
                resetFormAndImages(type);
              }}
              className="text-gray-400 hover:text-gray-600"
            >
              <FaClose />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {renderFormFields()}
            </div>

            {/* Status field for editing */}
            {isEdit && (
              <div className="flex items-center mt-6">
                <input
                  type="checkbox"
                  id="active"
                  checked={formData.active || false}
                  onChange={(e) => handleFormChange("active", e.target.checked)}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                />
                <label htmlFor="active" className="ml-2 text-sm text-gray-700">
                  Active
                </label>
              </div>
            )}

            <div className="mt-8 flex justify-end space-x-4">
              <button
                type="button"
                onClick={() => {
                  setShowAddModal(false);
                  setEditingItem(null);
                  setEditFormData({});
                  resetFormAndImages(type);
                }}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
              >
                <FaSave className="mr-2" />
                {isEdit ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <div className="h-full flex-1 flex flex-col overflow-hidden bg-gray-50 min-h-0">
      {/* Top Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-200 shrink-0 z-20">
        <div className="px-6 py-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {/* Mobile: toggle sidebar overlay */}
              <button
                onClick={() => setMobileSidebarOpen((prev) => !prev)}
                className="p-2 rounded-lg hover:bg-gray-100 md:hidden text-gray-600"
                aria-label="Toggle menu"
              >
                {mobileSidebarOpen ? <FaTimes /> : <FaBars />}
              </button>
              {/* Desktop: toggle sidebar collapse */}
              <button
                onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                className="p-2 rounded-lg hover:bg-gray-100 hidden md:flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors"
                aria-label={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
              >
                <FaBars />
              </button>
              <span className="text-sm font-semibold text-gray-700 hidden sm:inline">
                Activity Management
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <div className="relative">

              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile sidebar overlay - closes when clicking backdrop */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 md:hidden"
          onClick={() => setMobileSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="flex-1 flex overflow-hidden min-h-0 relative">
        {/* Sidebar - on mobile: fixed overlay when open; on desktop: inline fixed full-height, collapse possible */}
        <aside
          className={`
          bg-white border-r border-gray-200 transition-all duration-300
          shrink-0 h-full overflow-y-auto flex flex-col
          ${isSidebarCollapsed ? "w-0 md:w-20 hidden md:flex" : "w-64"}
          ${mobileSidebarOpen ? "fixed left-0 top-0 bottom-0 z-50 w-64 shadow-xl flex" : "hidden md:flex"}
        `}
        >
          <div className="p-4 h-full flex flex-col">
            <div className="flex items-center justify-between mb-4 md:mb-2 md:justify-start">
              <span className="font-semibold text-gray-800 md:hidden">Menu</span>
              <button
                onClick={() => setMobileSidebarOpen(false)}
                className="p-2 rounded-lg hover:bg-gray-100 md:hidden"
                aria-label="Close menu"
              >
                <FaTimes />
              </button>
            </div>
            <nav className="space-y-1 flex-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    setActiveSection(item.id);
                    setSearchTerm("");
                    setCountryFilter("");
                    setCityFilter("");
                    setActivityFilter("");
                    setOptionCountryFilter("");
                    setOptionCityFilter("");
                    setOptionActivityFilter("");
                    setMobileSidebarOpen(false);
                  }}
                  title={isSidebarCollapsed ? item.label : undefined}
                  className={`
                    w-full flex items-center px-3 py-2.5 rounded-lg transition-colors text-left
                    ${activeSection === item.id
                      ? "bg-blue-50 text-blue-600 font-semibold"
                      : "text-gray-700 hover:bg-gray-100"
                    }
                  `}
                >
                  <div className={`text-lg ${isSidebarCollapsed ? "mx-auto" : "mr-3"}`}>
                    {item.icon}
                  </div>
                  {!isSidebarCollapsed && (
                    <span className="font-medium">{item.label}</span>
                  )}
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Main Content Area: scrolls independently with smooth scrolling */}
        <main
          className="flex-1 h-full overflow-y-auto p-4 md:p-6 transition-all duration-300 min-w-0 bg-gray-50"
        >
          {/* Loading State */}
          {loading ? (
            <div className="flex items-center justify-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
          ) : (
            <>
              {/* Content Area */}
              <div className="max-w-full">
                {activeSection === "dashboard" && renderDashboard()}
                {activeSection === "countries" && renderCountries()}
                {activeSection === "cities" && renderCities()}
                {activeSection === "activities" && renderActivities()}
                {activeSection === "options" && renderOptions()}
                {activeSection === "visitor-types" && renderVisitorTypes()}{" "}
                {activeSection === "time-pricing" && renderTimePricing()}
                {activeSection === "bookings" && renderBookings()}
                {activeSection === "currencies" && renderCurrencies()}
                {activeSection === "reports" && renderReports()}
              </div>
            </>
          )}
        </main>
      </div>

      {/* Modals */}
      {renderModal()}

      {/* Manage Time Slots Modal - root level so it works from Options and Edit Option */}
      {timeSlotsModalOption && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[60] p-4" onClick={() => { setTimeSlotsModalOption(null); setEditingSlotId(null); }}>
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-bold text-gray-900">Manage Time Slots – {timeSlotsModalOption.name}</h3>
              <button type="button" onClick={() => { setTimeSlotsModalOption(null); setEditingSlotId(null); }} className="p-2 rounded-lg hover:bg-gray-100 text-gray-600">
                <FaTimes className="w-5 h-5" />
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div className="flex flex-wrap gap-3 items-end">
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Start</label>
                  <input type="text" value={newSlotForm.startTime} onChange={(e) => setNewSlotForm((p) => ({ ...p, startTime: e.target.value }))} placeholder="10:00" className="w-24 px-2 py-1.5 border rounded" />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">End</label>
                  <input type="text" value={newSlotForm.endTime} onChange={(e) => setNewSlotForm((p) => ({ ...p, endTime: e.target.value }))} placeholder="11:00" className="w-24 px-2 py-1.5 border rounded" />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Capacity</label>
                  <input type="number" min={1} value={newSlotForm.capacity} onChange={(e) => setNewSlotForm((p) => ({ ...p, capacity: parseInt(e.target.value, 10) || 1 }))} className="w-20 px-2 py-1.5 border rounded" />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Label (optional)</label>
                  <input type="text" value={newSlotForm.label} onChange={(e) => setNewSlotForm((p) => ({ ...p, label: e.target.value }))} placeholder="e.g. Morning" className="w-28 px-2 py-1.5 border rounded" />
                </div>
                <button
                  type="button"
                  onClick={async () => {
                    try {
                      if (editingSlotId) {
                        await axios.put(`${API_BASE_URL}/api/activity/admin/time-slots/${editingSlotId}`, {
                          startTime: newSlotForm.startTime,
                          endTime: newSlotForm.endTime,
                          capacity: newSlotForm.capacity,
                          label: newSlotForm.label || undefined,
                        });
                        setEditingSlotId(null);
                      } else {
                        await axios.post(`${API_BASE_URL}/api/activity/admin/time-slots`, {
                          activityOptionId: timeSlotsModalOption._id,
                          startTime: newSlotForm.startTime,
                          endTime: newSlotForm.endTime,
                          capacity: newSlotForm.capacity,
                          label: newSlotForm.label || undefined,
                        });
                      }
                      const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${timeSlotsModalOption._id}`);
                      setTimeSlotsList(res.data?.data || []);
                      setNewSlotForm({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" });
                    } catch (err) {
                      alert(err.response?.data?.error || "Failed to save slot.");
                    }
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
                >
                  {editingSlotId ? "Update Slot" : "Add Slot"}
                </button>
                {editingSlotId && (
                  <button type="button" onClick={() => { setEditingSlotId(null); setNewSlotForm({ startTime: "10:00", endTime: "11:00", capacity: 10, label: "" }); }} className="px-3 py-2 border rounded-lg text-sm">Cancel</button>
                )}
              </div>
              {timeSlotsLoading ? (
                <p className="text-gray-500">Loading slots…</p>
              ) : (
                <div className="border rounded-lg overflow-hidden">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="text-left px-3 py-2">Start</th>
                        <th className="text-left px-3 py-2">End</th>
                        <th className="text-left px-3 py-2">Capacity</th>
                        <th className="text-left px-3 py-2">Booked</th>
                        <th className="text-left px-3 py-2">Label</th>
                        <th className="text-right px-3 py-2">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timeSlotsList.length === 0 ? (
                        <tr><td colSpan={6} className="px-3 py-4 text-gray-500 text-center">No slots yet. Add one above.</td></tr>
                      ) : (
                        timeSlotsList.map((slot) => (
                          <tr key={slot._id} className="border-t">
                            <td className="px-3 py-2">{slot.startTime}</td>
                            <td className="px-3 py-2">{slot.endTime}</td>
                            <td className="px-3 py-2">{slot.capacity}</td>
                            <td className="px-3 py-2">{slot.bookedCount ?? 0}</td>
                            <td className="px-3 py-2">{slot.label || "—"}</td>
                            <td className="px-3 py-2 text-right space-x-2">
                              <button
                                type="button"
                                onClick={() => {
                                  setEditingSlotId(slot._id);
                                  setNewSlotForm({ startTime: slot.startTime || "10:00", endTime: slot.endTime || "11:00", capacity: slot.capacity || 10, label: slot.label || "" });
                                }}
                                className="text-blue-600 hover:text-blue-800 text-sm"
                              >
                                Edit
                              </button>
                              <button
                                type="button"
                                onClick={async () => {
                                  if (!confirm("Delete this slot? Existing bookings will keep the slot reference.")) return;
                                  try {
                                    await axios.delete(`${API_BASE_URL}/api/activity/admin/time-slots/${slot._id}`);
                                    const res = await axios.get(`${API_BASE_URL}/api/activity/admin/time-slots/${timeSlotsModalOption._id}`);
                                    setTimeSlotsList(res.data?.data || []);
                                    if (editingSlotId === slot._id) setEditingSlotId(null);
                                  } catch (err) {
                                    alert(err.response?.data?.error || "Failed to delete.");
                                  }
                                }}
                                className="text-red-600 hover:text-red-800 text-sm"
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showCustomModal && (
        <AdminCustomActivityModal
          onClose={() => setShowCustomModal(false)}
          onCreated={() => {
            fetchBookings();
            setShowCustomModal(false);
          }}
        />
      )}
    </div>
  );
};

export default AdminActivity;
